(function(){
  if ((window.__cfLoaded = window.__cfLoaded || {})['cf-enh-home']) return;
  window.__cfLoaded['cf-enh-home'] = true;
function useV2() {
  const [v, setV] = React.useState(() => window.__v2 || {});
  React.useEffect(() => {
    const handler = () => setV({ ...window.__v2 || {} });
    window.addEventListener("cf-v2-tweaks", handler);
    return () => window.removeEventListener("cf-v2-tweaks", handler);
  }, []);
  return v;
}
function HomePage({ go, t }) {
  const v2 = useV2();
  const featured = window.CATALOG.filter((c) => c.featured && c.accent).slice(0, 6);
  const newIn = window.CATALOG.filter((c) => !c.featured).slice(0, 4);
  const heroCity = window.CATALOG.find((c) => c.id === "sheffield") || window.CATALOG[0];
  return /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(HeroV2, { city: heroCity, go, mode: v2.heroMode || "model" }), /* @__PURE__ */ React.createElement(MarqueeStripV2, null), /* @__PURE__ */ React.createElement(SignatureProcess, { mode: v2.sceneMode || "scroll" }), /* @__PURE__ */ React.createElement(FeaturedCollection, { items: featured, go }), /* @__PURE__ */ React.createElement(TheTwelveGrid, { go }), /* @__PURE__ */ React.createElement(CommissionPreviewV2, { go }), /* @__PURE__ */ React.createElement(ARShelfModule, null), /* @__PURE__ */ React.createElement(PullQuoteV2, null), /* @__PURE__ */ React.createElement(ArchiveSection, { items: newIn, go }), /* @__PURE__ */ React.createElement(PressStripV2, null), /* @__PURE__ */ React.createElement(Footer, { go }));
}
function HeroV2({ city, go }) {
  const HARDCODED_FALLBACK_IDS = ["sheffield", "edinburgh", "whitby", "bath"];
  const SLIDE_IDS = typeof window !== "undefined" && Array.isArray(window.HERO_ROTATION) && window.HERO_ROTATION.length ? window.HERO_ROTATION : HARDCODED_FALLBACK_IDS;
  const slides = React.useMemo(() => {
    const out = [];
    const catalog = typeof window !== "undefined" && window.CATALOG || [];
    for (const entry of SLIDE_IDS) {
      if (typeof entry === "object" && entry && entry.coords && entry.image) {
        out.push({ city: entry, image: entry.image });
        continue;
      }
      const id = typeof entry === "string" ? entry : entry && entry.id;
      const force = typeof entry === "object" && entry && entry.image || null;
      if (!id) continue;
      const c = catalog.find((x) => x.id === id);
      if (!c) continue;
      const image = force || c.on_base || c.hero_label || c.photos && c.photos[0];
      if (!image) continue;
      out.push({ city: c, image });
    }
    if (out.length === 0 && city) {
      const image = city.on_base || city.hero_label || city.photos && city.photos[0] || "assets/cf-sheffield-on-base.png";
      out.push({ city, image });
    }
    return out;
  }, [city]);
  const [idx, setIdx] = React.useState(0);
  React.useEffect(() => {
    if (slides.length < 2) return;
    const t = setInterval(() => setIdx((i) => (i + 1) % slides.length), 5e3);
    return () => clearInterval(t);
  }, [slides.length]);
  const active = slides[idx] || { city, image: "assets/cf-sheffield-on-base.png" };
  const ac = active.city || {};
  const cityName = ac.name || "Sheffield \xB7 City Centre";
  const coordLat = ac.coords ? `${ac.coords.lat.toFixed(3)}\xB0 ${ac.coords.ns}` : "53.380\xB0 N";
  const coordLng = ac.coords ? `${Math.abs(ac.coords.lng).toFixed(3)}\xB0 ${ac.coords.ew}` : "1.464\xB0 W";
  const price = ac.price || 45;
  const volumeNo = String(idx + 1).padStart(2, "0");
  const totalNo = String(Math.max(slides.length, 12)).padStart(2, "0");
  return /* @__PURE__ */ React.createElement("section", { className: "hero-plate" }, slides.map((s, i) => /* @__PURE__ */ React.createElement(
    "img",
    {
      key: s.city.id,
      src: s.image,
      alt: `${s.city.name} \u2014 9 cm plate on its base`,
      "aria-hidden": i !== idx,
      style: {
        opacity: i === idx ? 1 : 0,
        transition: "opacity 1.2s cubic-bezier(.4,.0,.2,1)",
        zIndex: i === idx ? 1 : 0
      }
    }
  )), /* @__PURE__ */ React.createElement("div", { style: {
    position: "absolute",
    inset: 0,
    pointerEvents: "none",
    zIndex: 1,
    background: "linear-gradient(180deg, rgba(14,17,22,0.42) 0%, rgba(14,17,22,0) 22%, rgba(14,17,22,0) 55%, rgba(14,17,22,0.65) 100%),linear-gradient(90deg, rgba(14,17,22,0.42) 0%, rgba(14,17,22,0) 38%)"
  } }), /* @__PURE__ */ React.createElement("span", { className: "hero-plate__corner hero-plate__corner--tl", "aria-hidden": "true" }), /* @__PURE__ */ React.createElement("span", { className: "hero-plate__corner hero-plate__corner--tr", "aria-hidden": "true" }), /* @__PURE__ */ React.createElement("span", { className: "hero-plate__corner hero-plate__corner--bl", "aria-hidden": "true" }), /* @__PURE__ */ React.createElement("span", { className: "hero-plate__corner hero-plate__corner--br", "aria-hidden": "true" }), /* @__PURE__ */ React.createElement("div", { className: "hero-plate__rail" }, /* @__PURE__ */ React.createElement("div", { className: "hero-plate__rail-vertical" }, "Plate \xB7 No. ", volumeNo, " of ", totalNo), /* @__PURE__ */ React.createElement("div", { className: "hero-plate__rail-tabular" }, /* @__PURE__ */ React.createElement("div", { style: { transition: "opacity .4s", opacity: 1 }, key: `lat-${idx}` }, coordLat), /* @__PURE__ */ React.createElement("div", { style: { transition: "opacity .4s", opacity: 1 }, key: `lng-${idx}` }, coordLng), /* @__PURE__ */ React.createElement("div", { className: "hero-plate__rail-divider" }), /* @__PURE__ */ React.createElement("div", { className: "hero-plate__rail-price" }, "\xA3", price, " \xB7 7 days"))), /* @__PURE__ */ React.createElement("div", { className: "hero-cap" }, /* @__PURE__ */ React.createElement("div", { className: "hero-plate__cap-kicker" }, /* @__PURE__ */ React.createElement("span", { className: "hero-plate__cap-rule" }), /* @__PURE__ */ React.createElement("span", null, "Volume 02 \xB7 ", cityName)), /* @__PURE__ */ React.createElement("h1", null, "Your kilometre, ", /* @__PURE__ */ React.createElement("em", null, "at 9 cm.")), /* @__PURE__ */ React.createElement("div", { className: "hero-plate__cta-row" }, /* @__PURE__ */ React.createElement("button", { className: "btn-v2", onClick: () => go("atlas") }, "Browse the twelve ", /* @__PURE__ */ React.createElement("span", { className: "btn-arrow" }, Icon.arrow)), /* @__PURE__ */ React.createElement("button", { className: "btn-v2 btn-v2-ghost-light", onClick: () => go("atelier") }, "Commission your kilometre"))), /* @__PURE__ */ React.createElement("div", { className: "hero-plate__fig" }, /* @__PURE__ */ React.createElement("div", { className: "hero-plate__fig-label" }, "Fig. ", volumeNo), /* @__PURE__ */ React.createElement("div", { className: "hero-plate__fig-stack" }, /* @__PURE__ */ React.createElement("span", null, "1 km \xD7 1 km"), /* @__PURE__ */ React.createElement("span", null, "1 : 11 000"), /* @__PURE__ */ React.createElement("span", null, "0.16 mm layer"), /* @__PURE__ */ React.createElement("span", null, "matte PLA \xB7 graphite base"))), slides.length > 1 && /* @__PURE__ */ React.createElement("div", { className: "hero-plate__slide-dots", "aria-label": "Hero slide selector" }, slides.map((s, i) => /* @__PURE__ */ React.createElement(
    "button",
    {
      key: s.city.id,
      type: "button",
      onClick: () => setIdx(i),
      "aria-label": `Show ${s.city.name}`,
      "aria-current": i === idx ? "true" : void 0,
      "data-active": i === idx ? "true" : "false"
    }
  ))));
}
function HeroModel({ city }) {
  const glb = city.model_glb || (city.id === "sheffield" ? "assets/products/sheffield.glb" : null);
  const fallback = city.on_base || city.photos && city.photos[0] || city.photo;
  const _sLat = city.coords.ns === "S" ? -city.coords.lat : city.coords.lat;
  const _sLng = city.coords.ew === "W" ? -city.coords.lng : city.coords.lng;
  const label3d = {
    title: (city.name || "").toUpperCase(),
    subline: "",
    coord: window.fmtCoord ? window.fmtCoord(_sLat, _sLng) : `${city.coords.lat.toFixed(3)}\xB0 ${city.coords.ns} \xB7 ${Math.abs(city.coords.lng).toFixed(3)}\xB0 ${city.coords.ew}`,
    showCoords: true
  };
  return /* @__PURE__ */ React.createElement("div", { style: {
    position: "relative",
    height: 700,
    background: "var(--mist)",
    border: "1px solid var(--ink)",
    overflow: "hidden"
  } }, /* @__PURE__ */ React.createElement(Model3DViewer, { url: glb, fallback, label: label3d, height: 700, autoRotateSpeed: 0.6 }), /* @__PURE__ */ React.createElement("div", { style: {
    position: "absolute",
    top: 18,
    left: 18,
    background: "var(--bone)",
    border: "1px solid var(--ink)",
    padding: "8px 12px",
    display: "flex",
    alignItems: "center",
    gap: 10
  } }, /* @__PURE__ */ React.createElement("span", { className: "eyebrow", style: { fontSize: 9 } }, city.name.toUpperCase(), " CITY CENTRE \xB7 9 CM \xB7 1:11000")), /* @__PURE__ */ React.createElement(CornerMarks, null));
}
function HeroPhotoStack({ city }) {
  const photos = city.photos || [city.on_base, city.photo].filter(Boolean);
  const [active, setActive] = React.useState(0);
  return /* @__PURE__ */ React.createElement("div", { style: { position: "relative", height: 700, display: "grid", gridTemplateRows: "1fr 110px", gap: 14 } }, /* @__PURE__ */ React.createElement("div", { style: { position: "relative", border: "1px solid var(--ink)", overflow: "hidden", background: "var(--bone)" } }, photos.map((src, i) => /* @__PURE__ */ React.createElement(
    "img",
    {
      key: src,
      src,
      alt: city.name,
      className: "img-cinema",
      style: {
        position: "absolute",
        inset: 0,
        width: "100%",
        height: "100%",
        objectFit: "cover",
        opacity: i === active ? 1 : 0,
        transition: "opacity .5s ease"
      }
    }
  )), /* @__PURE__ */ React.createElement("div", { style: {
    position: "absolute",
    top: 18,
    left: 18,
    background: "var(--bone)",
    border: "1px solid var(--ink)",
    padding: "8px 12px"
  } }, /* @__PURE__ */ React.createElement("span", { className: "eyebrow", style: { fontSize: 9 } }, "SHEFFIELD \xB7 FIG. ", String(active + 1).padStart(2, "0"), " OF ", String(photos.length).padStart(2, "0"))), /* @__PURE__ */ React.createElement(CornerMarks, null)), /* @__PURE__ */ React.createElement("div", { style: { display: "grid", gridTemplateColumns: `repeat(${Math.min(photos.length, 6)}, 1fr)`, gap: 8 } }, photos.slice(0, 6).map((src, i) => /* @__PURE__ */ React.createElement(
    "button",
    {
      key: src,
      onMouseEnter: () => setActive(i),
      onFocus: () => setActive(i),
      style: {
        display: "block",
        border: `1px solid ${i === active ? "var(--ink)" : "var(--line)"}`,
        background: "var(--bone)",
        overflow: "hidden",
        height: "100%"
      }
    },
    /* @__PURE__ */ React.createElement(
      "img",
      {
        src,
        alt: "",
        className: "img-editorial",
        style: {
          width: "100%",
          height: "100%",
          objectFit: "cover",
          opacity: i === active ? 1 : 0.85
        }
      }
    )
  ))));
}
function HeroPlan({ city }) {
  return /* @__PURE__ */ React.createElement("div", { style: { position: "relative", height: 700, border: "1px solid var(--ink)", overflow: "hidden", background: "var(--bone)" } }, /* @__PURE__ */ React.createElement(StyledMap, { seed: city.id + "-plan", bbox: { x: 30, y: 30, w: 38, h: 38, r: 0 } }), /* @__PURE__ */ React.createElement("div", { style: {
    position: "absolute",
    top: 18,
    left: 18,
    background: "var(--bone)",
    border: "1px solid var(--ink)",
    padding: "10px 14px"
  } }, /* @__PURE__ */ React.createElement("div", { className: "eyebrow", style: { fontSize: 9 } }, "PLAN \xB7 1.00 \xD7 1.00 KM"), /* @__PURE__ */ React.createElement("div", { style: { marginTop: 6, fontSize: 13, fontWeight: 600 } }, city.name, " \xB7 City Centre")), /* @__PURE__ */ React.createElement(CornerMarks, null));
}
function HeroTriptych({ city }) {
  const main = city.on_base || city.photos && city.photos[0] || city.photo;
  const detail = city.photos && city.photos[2] || city.photo;
  return /* @__PURE__ */ React.createElement("div", { style: { height: 700, display: "grid", gridTemplateRows: "1.4fr 1fr", gap: 14 } }, /* @__PURE__ */ React.createElement("div", { style: { position: "relative", border: "1px solid var(--ink)", overflow: "hidden", background: "var(--bone)" } }, /* @__PURE__ */ React.createElement(
    "img",
    {
      src: main,
      alt: city.name,
      className: "img-cinema",
      style: { width: "100%", height: "100%", objectFit: "cover" }
    }
  ), /* @__PURE__ */ React.createElement("div", { style: { position: "absolute", top: 18, left: 18, background: "var(--bone)", border: "1px solid var(--ink)", padding: "8px 12px" } }, /* @__PURE__ */ React.createElement("span", { className: "eyebrow", style: { fontSize: 9 } }, "01 \xB7 OBJECT"))), /* @__PURE__ */ React.createElement("div", { style: { display: "grid", gridTemplateColumns: "1fr 1fr", gap: 14 } }, /* @__PURE__ */ React.createElement("div", { style: { position: "relative", border: "1px solid var(--ink)", overflow: "hidden", background: "var(--bone)" } }, /* @__PURE__ */ React.createElement(StyledMap, { seed: city.id + "-tri", bbox: { x: 30, y: 30, w: 38, h: 38, r: 0 } }), /* @__PURE__ */ React.createElement("div", { style: { position: "absolute", top: 14, left: 14, background: "var(--bone)", border: "1px solid var(--ink)", padding: "5px 10px" } }, /* @__PURE__ */ React.createElement("span", { className: "eyebrow", style: { fontSize: 9 } }, "02 \xB7 PLAN"))), /* @__PURE__ */ React.createElement("div", { style: { position: "relative", border: "1px solid var(--ink)", overflow: "hidden", background: "var(--bone)" } }, /* @__PURE__ */ React.createElement(
    "img",
    {
      src: detail,
      alt: "",
      className: "img-cinema",
      style: { width: "100%", height: "100%", objectFit: "cover" }
    }
  ), /* @__PURE__ */ React.createElement("div", { style: { position: "absolute", top: 14, left: 14, background: "var(--bone)", border: "1px solid var(--ink)", padding: "5px 10px" } }, /* @__PURE__ */ React.createElement("span", { className: "eyebrow", style: { fontSize: 9 } }, "03 \xB7 DETAIL")))));
}
function MarqueeStripV2() {
  const items = [
    "EA LIDAR \xB7 1 M RESOLUTION",
    "OPENSTREETMAP FOOTPRINTS",
    "PLA \xB7 WHITE \xB7 BAMBU LAB",
    "MADE IN SHEFFIELD",
    "CITYFORM.CO \xB7 ETSY/CITYFORMUK",
    "FREE UK SHIPPING OVER \xA375",
    "ONE FORMAT \xB7 9 CM SQUARE",
    "TWELVE CITIES \xB7 ONE ATLAS",
    "COMMISSIONS WELCOME"
  ];
  const Row = () => /* @__PURE__ */ React.createElement("div", { className: "marquee-row" }, items.map((s, i) => /* @__PURE__ */ React.createElement("span", { key: i, style: { display: "inline-flex", alignItems: "center", gap: 64, fontSize: 11, letterSpacing: "0.32em", fontWeight: 500, color: "var(--ink-soft)" } }, s, /* @__PURE__ */ React.createElement("span", { style: { width: 6, height: 6, background: "var(--ink)", display: "inline-block" } }))));
  return /* @__PURE__ */ React.createElement("div", { style: { background: "var(--bone)", borderBottom: "1px solid var(--line)", borderTop: "1px solid var(--line)", overflow: "hidden", padding: "18px 0" } }, /* @__PURE__ */ React.createElement("div", { className: "marquee-track" }, /* @__PURE__ */ React.createElement(Row, null), /* @__PURE__ */ React.createElement(Row, null)));
}
function SignatureProcess({ mode = "scroll" }) {
  const [ref, scrollP] = useScrollProgress();
  const [autoP, setAutoP] = React.useState(0);
  React.useEffect(() => {
    if (mode !== "auto") return;
    let raf, t0 = performance.now();
    const tick = (t) => {
      const dt = (t - t0) / 1e3;
      const cycle = 18;
      setAutoP(dt % cycle / cycle);
      raf = requestAnimationFrame(tick);
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, [mode]);
  const p = mode === "scroll" ? scrollP : mode === "auto" ? autoP : 1;
  const phaseProgress = (i) => {
    const start = i / 4, end = (i + 1) / 4;
    if (p < start - 0.06) return 0;
    if (p > end + 0.06) return 0;
    if (p < start) return (p - (start - 0.06)) / 0.06;
    if (p > end) return 1 - (p - end) / 0.06;
    return 1;
  };
  const activePhase = mode === "off" ? 3 : Math.min(3, Math.floor(p * 4 + 1e-3));
  const heightVh = mode === "scroll" ? 360 : 100;
  const phases = [
    {
      n: "01",
      title: "Survey",
      kicker: "ENVIRONMENT AGENCY \xB7 LIDAR",
      body: "A 1 m resolution scan of the ground and everything on it. Released by the EA under the Open Government Licence. We crop a single square kilometre.",
      side: "47.3 MB \xB7 DTM + DSM"
    },
    {
      n: "02",
      title: "Footprints",
      kicker: "OPENSTREETMAP \xB7 BUILDINGS, WATER",
      body: "OSM gives us the polygons: roof outlines, water boundaries, bridges. Each shape is closed and oriented before it meets the mesh.",
      side: "overpass-turbo \xB7 1.04 sec"
    },
    {
      n: "03",
      title: "Mesh",
      kicker: "WATERTIGHT \xB7 MEASURED ROOF SURFACES",
      body: "The LIDAR heightfield and OSM footprints are fused into a single watertight mesh. Water is cut down by 1 mm to read as river, not pavement.",
      side: "tier-3 \xB7 ~3.2 M tris"
    },
    {
      n: "04",
      title: "Object",
      kicker: "BAMBU LAB \xB7 PLA WHITE \xB7 9 CM",
      body: "Printed in white PLA, hand-finished, seated on a graphite base. Packed in a 3D-printed storage case, then a kraft mailer and a box or padded bag, with data attribution included.",
      side: "7 days \xB7 made to order"
    }
  ];
  const sectionContent = /* @__PURE__ */ React.createElement("div", { className: "container signature-process", "data-mode": mode }, /* @__PURE__ */ React.createElement("div", { className: "coord-grid", style: { opacity: 0.35 } }), /* @__PURE__ */ React.createElement("div", { className: "signature-process__copy" }, /* @__PURE__ */ React.createElement(Reveal, { kind: "reveal", style: { marginBottom: 32, display: "flex", alignItems: "center", gap: 14 } }, /* @__PURE__ */ React.createElement("span", { className: "signature-process__eyebrow-rule" }), /* @__PURE__ */ React.createElement("span", { className: "eyebrow", style: { fontSize: 10 } }, "THE PROCESS \xB7 IN FOUR ACTS")), /* @__PURE__ */ React.createElement(Reveal, { kind: "reveal", delay: 120 }, /* @__PURE__ */ React.createElement("h2", { className: "display-section signature-process__heading" }, "How a place", /* @__PURE__ */ React.createElement("br", null), "becomes a shelf object.")), /* @__PURE__ */ React.createElement("div", { className: "signature-process__phases" }, phases.map((ph, i) => {
    const active = i === activePhase || mode === "off";
    return /* @__PURE__ */ React.createElement(
      "div",
      {
        key: i,
        className: "signature-process__phase",
        "data-active": active ? "true" : "false",
        "data-mode": mode
      },
      /* @__PURE__ */ React.createElement("div", { className: "signature-process__phase-number tnum" }, ph.n),
      /* @__PURE__ */ React.createElement("div", { className: "signature-process__phase-body" }, /* @__PURE__ */ React.createElement("div", { className: "signature-process__phase-title" }, ph.title), /* @__PURE__ */ React.createElement("div", { className: "eyebrow signature-process__phase-kicker" }, ph.kicker), /* @__PURE__ */ React.createElement("p", { className: "body signature-process__phase-copy" }, ph.body)),
      /* @__PURE__ */ React.createElement("div", { className: "signature-process__phase-side" }, /* @__PURE__ */ React.createElement("span", { className: "tnum" }, ph.side))
    );
  })), mode === "scroll" && /* @__PURE__ */ React.createElement("div", { className: "signature-process__progress" }, /* @__PURE__ */ React.createElement("div", { className: "eyebrow", style: { marginBottom: 10 } }, "SCROLL PROGRESS"), /* @__PURE__ */ React.createElement("div", { className: "signature-process__progress-track" }, /* @__PURE__ */ React.createElement("div", { className: "signature-process__progress-fill", style: { width: `${p * 100}%` } }), [0.25, 0.5, 0.75].map((x) => /* @__PURE__ */ React.createElement("div", { key: x, className: "signature-process__progress-tick", style: { left: `${x * 100}%` } }))), /* @__PURE__ */ React.createElement("div", { className: "signature-process__progress-labels" }, phases.map((ph, i) => /* @__PURE__ */ React.createElement(
    "span",
    {
      key: i,
      className: "eyebrow",
      "data-active": i === activePhase ? "true" : "false"
    },
    ph.n
  ))))), /* @__PURE__ */ React.createElement("div", { className: "signature-process__stage" }, /* @__PURE__ */ React.createElement(ProcessStage, { progress: p, phaseProgress, activePhase, mode })));
  return /* @__PURE__ */ React.createElement(
    "section",
    {
      ref,
      className: "signature-process-section",
      "data-mode": mode
    },
    mode === "scroll" ? /* @__PURE__ */ React.createElement("div", { className: "signature-process-section__pin-wrap" }, /* @__PURE__ */ React.createElement("div", { className: "scene-pin" }, sectionContent)) : sectionContent
  );
}
function StageBadge({ text, sub }) {
  return /* @__PURE__ */ React.createElement("div", { style: {
    position: "absolute",
    top: 16,
    left: 16,
    background: "rgba(247,248,246,0.82)",
    backdropFilter: "blur(2px)",
    color: "var(--ink)",
    border: "1px solid var(--ink)",
    padding: "7px 12px"
  } }, /* @__PURE__ */ React.createElement("div", { className: "eyebrow", style: { fontSize: 9, color: "var(--stone)", marginBottom: 3 } }, sub), /* @__PURE__ */ React.createElement("div", { style: { fontSize: 12, fontWeight: 600, letterSpacing: "-0.005em" } }, text));
}
function ProcessStage({ progress, phaseProgress, activePhase, mode }) {
  const wrapRef = React.useRef(null);
  const canvasRef = React.useRef(null);
  const pRef = React.useRef(0);
  pRef.current = mode === "off" ? 4 : Math.max(0, Math.min(3.999, progress * 4));
  const hfRef = React.useRef(null);
  const tileRef = React.useRef(null);
  React.useEffect(() => {
    let alive = true;
    const cfp = typeof window !== "undefined" && window.cfPaths || {};
    const dtmUrl = cfp.dtm || "assets/sheffield_dtm.json";
    const tileUrl = cfp.tile || "assets/sheffield_tile.json";
    fetch(dtmUrl).then((r) => r.json()).then((j) => {
      if (alive) hfRef.current = { h: j.h, grid: j.grid, min: j.metres_min, span: j.metres_span };
    }).catch(() => {
    });
    fetch(tileUrl).then((r) => r.json()).then((j) => {
      if (alive) tileRef.current = j;
    }).catch(() => {
    });
    return () => {
      alive = false;
    };
  }, []);
  const phaseNow = mode === "off" ? 4 : progress * 4;
  const [show3d, setShow3d] = React.useState(false);
  React.useEffect(() => {
    if (phaseNow > 0 && !show3d) setShow3d(true);
  }, [phaseNow, show3d]);
  const sm01 = (e0, e1, x) => {
    const t = Math.max(0, Math.min(1, (x - e0) / (e1 - e0)));
    return t * t * (3 - 2 * t);
  };
  const obj3dOpacity = mode === "off" ? 1 : sm01(3.3, 3.65, phaseNow);
  const autoRotateNow = mode === "off" ? true : phaseNow > 3.6;
  React.useEffect(() => {
    const cv = canvasRef.current, wrap = wrapRef.current;
    if (!cv || !wrap) return;
    const ctx = cv.getContext("2d");
    const DPR = Math.min(2, window.devicePixelRatio || 1);
    let raf = 0;
    const ro = new ResizeObserver(() => {
    });
    ro.observe(wrap);
    const clamp = (v, a, b) => v < a ? a : v > b ? b : v;
    const lerp = (a, b, t) => a + (b - a) * t;
    const easeOut = (t) => 1 - Math.pow(1 - t, 3);
    const smooth = (e0, e1, x) => {
      const t = clamp((x - e0) / (e1 - e0), 0, 1);
      return t * t * (3 - 2 * t);
    };
    const mix = (c1, c2, t) => {
      const p = (h) => [parseInt(h.slice(1, 3), 16), parseInt(h.slice(3, 5), 16), parseInt(h.slice(5, 7), 16)];
      const a = p(c1), b = p(c2);
      return `rgb(${a.map((v, i) => Math.round(lerp(v, b[i], t))).join(",")})`;
    };
    function sampleH(gx, gy) {
      const hf = hfRef.current;
      if (!hf) {
        const cx = gx - 0.5, cy = gy - 0.5;
        return clamp(Math.exp(-(cx * cx + cy * cy) * 5) * 0.7 + Math.exp(-((cx - 0.2) ** 2 + (cy + 0.15) ** 2) * 12) * 0.4, 0, 1);
      }
      const G = hf.grid, H = hf.h;
      const x = clamp(gx * (G - 1), 0, G - 1), y = clamp(gy * (G - 1), 0, G - 1);
      const x0 = x | 0, y0 = y | 0, fx = x - x0, fy = y - y0;
      const x1 = Math.min(x0 + 1, G - 1), y1 = Math.min(y0 + 1, G - 1);
      const a = H[y0 * G + x0], b = H[y0 * G + x1], c = H[y1 * G + x0], d = H[y1 * G + x1];
      return lerp(lerp(a, b, fx), lerp(c, d, fx), fy);
    }
    function project(gx, gy, h, cam, W, Hh) {
      const rgx = gy, rgy = 1 - gx;
      const wx = rgx - 0.5, wy = rgy - 0.5;
      const ix = (wx - wy) * 0.86, iy = (wx + wy) * 0.43 - h * cam.lift;
      const t = cam.tilt;
      const sx = lerp(wx, ix, t), sy = lerp(wy, iy, t);
      const sc = Math.min(W, Hh) * cam.zoom;
      return [W / 2 + sx * sc, Hh / 2 + sy * sc + cam.yShift * Hh];
    }
    function rig(p) {
      let tilt = lerp(1, 0.06, smooth(0.55, 1.4, p));
      tilt = lerp(tilt, 1, smooth(1.9, 2.6, p));
      const a0 = smooth(0, 1, p), a2 = smooth(2, 3, p);
      let zoom = lerp(0.66, 0.58, smooth(2.6, 3.4, p));
      zoom = lerp(zoom, 0.5, smooth(3, 3.35, p));
      return { tilt, lift: lerp(0.2, 0.46, a2) * lerp(0.4, 1, a0), zoom, yShift: lerp(0, 0.055, smooth(3.1, 3.9, p)) };
    }
    const ACC = "#D34833", TN = 46;
    const ringPts = (r, z, cam, W, H) => {
      const o = [];
      for (const q of r) o.push(project(q[0], q[1], z, cam, W, H));
      return o;
    };
    const cen = (r) => {
      let x = 0, y = 0;
      for (const q of r) {
        x += q[0];
        y += q[1];
      }
      return [x / r.length, y / r.length];
    };
    const poly = (P, fill) => {
      ctx.beginPath();
      P.forEach((p, j) => j ? ctx.lineTo(p[0], p[1]) : ctx.moveTo(p[0], p[1]));
      ctx.closePath();
      if (fill) {
        ctx.fillStyle = fill;
        ctx.fill();
      }
    };
    function drawDots(W, H, cam, ph, al) {
      const a = smooth(0, 1, ph), rise = easeOut(a), scan = ph < 1 ? a : 1;
      ctx.globalAlpha = al;
      for (let gy = 0; gy < 100; gy++) for (let gx = 0; gx < 100; gx++) {
        const u = gx / 99, v = gy / 99, hh = sampleH(u, v);
        const lo = clamp((scan - v) * 6 + 0.3, 0, 1);
        const [sx, sy] = project(u, v, hh * rise * lo, cam, W, H);
        const sh = (0.16 + hh * 0.62) * (0.35 + 0.65 * lo);
        ctx.fillStyle = `rgba(26,31,38,${sh.toFixed(3)})`;
        const rr = (0.5 + hh * 2) * DPR;
        ctx.fillRect(sx - rr / 2, sy - rr / 2, rr, rr);
      }
      if (ph < 1.05) {
        const p0 = project(0, scan, 0, cam, W, H), p1 = project(1, scan, 0, cam, W, H);
        ctx.globalAlpha = al * 0.9;
        ctx.strokeStyle = ACC;
        ctx.lineWidth = 1.4 * DPR;
        ctx.beginPath();
        ctx.moveTo(p0[0], p0[1]);
        ctx.lineTo(p1[0], p1[1]);
        ctx.stroke();
      }
      ctx.globalAlpha = 1;
      const hf = hfRef.current;
      if (hf && ph < 1.4) {
        const la = clamp(a * 1.5 - 0.3, 0, 1) * clamp(1 - (ph - 0.8) * 3, 0, 1);
        if (la > 0.02) {
          spot(W, H, cam, 0.3, 0.34, la);
          spot(W, H, cam, 0.66, 0.58, la);
        }
      }
    }
    function spot(W, H, cam, u, v, al) {
      const hf = hfRef.current;
      const hh = sampleH(u, v), m = (hf.min + hh * hf.span).toFixed(1) + " m";
      const [sx, sy] = project(u, v, hh * cam.lift, cam, W, H);
      ctx.globalAlpha = al;
      ctx.fillStyle = ACC;
      ctx.beginPath();
      ctx.arc(sx, sy, 3 * DPR, 0, 7);
      ctx.fill();
      ctx.strokeStyle = "#1A1F26";
      ctx.lineWidth = DPR;
      ctx.beginPath();
      ctx.moveTo(sx, sy);
      ctx.lineTo(sx + 22 * DPR, sy - 22 * DPR);
      ctx.stroke();
      ctx.fillStyle = "#1A1F26";
      ctx.font = `${11 * DPR}px ui-monospace,Menlo,monospace`;
      ctx.fillText(m, sx + 26 * DPR, sy - 22 * DPR);
      ctx.globalAlpha = 1;
    }
    function drawSurface(W, H, cam, ph, al) {
      const grow = easeOut(smooth(1.05, 2.1, ph));
      ctx.globalAlpha = al;
      ctx.lineJoin = "round";
      const quads = [];
      for (let gy = 0; gy < TN; gy++) for (let gx = 0; gx < TN; gx++) {
        const u0 = gx / TN, u1 = (gx + 1) / TN, v0 = gy / TN, v1 = (gy + 1) / TN;
        const h00 = sampleH(u0, v0), h10 = sampleH(u1, v0), h11 = sampleH(u1, v1), h01 = sampleH(u0, v1);
        const ha = (h00 + h10 + h11 + h01) / 4 * grow;
        const P = [project(u0, v0, h00 * grow, cam, W, H), project(u1, v0, h10 * grow, cam, W, H), project(u1, v1, h11 * grow, cam, W, H), project(u0, v1, h01 * grow, cam, W, H)];
        const dzx = h10 - h00, dzy = h01 - h00, nl = clamp(0.78 + (-dzx * 1.6 - dzy * 1.1), 0.6, 1.16);
        const tt = clamp(ha * 1.15, 0, 1);
        const col = `rgb(${clamp(lerp(228, 183, tt) * nl | 0, 0, 255)},${clamp(lerp(231, 188, tt) * nl | 0, 0, 255)},${clamp(lerp(225, 180, tt) * nl | 0, 0, 255)})`;
        quads.push({ P, col, d: P[0][1] + P[1][1] + P[2][1] + P[3][1] });
      }
      quads.sort((a, b) => a.d - b.d);
      for (const q of quads) {
        ctx.fillStyle = q.col;
        ctx.beginPath();
        ctx.moveTo(q.P[0][0], q.P[0][1]);
        ctx.lineTo(q.P[1][0], q.P[1][1]);
        ctx.lineTo(q.P[2][0], q.P[2][1]);
        ctx.lineTo(q.P[3][0], q.P[3][1]);
        ctx.closePath();
        ctx.fill();
        ctx.strokeStyle = "rgba(120,126,118,.18)";
        ctx.lineWidth = 0.5 * DPR;
        ctx.stroke();
      }
      ctx.globalAlpha = 1;
    }
    function drawSkirt(W, H, cam, ph, al) {
      const grow = easeOut(smooth(1.05, 2.1, ph));
      ctx.globalAlpha = al;
      const edges = [(k) => [k, 1], (k) => [1, k], (k) => [k, 0], (k) => [0, k]];
      const strips = edges.map((f) => {
        const top = [], bot = [];
        let d = 0;
        for (let k = 0; k <= TN; k++) {
          const t = k / TN, c = f(t);
          const tp = project(c[0], c[1], sampleH(c[0], c[1]) * grow, cam, W, H);
          const bp = project(c[0], c[1], 0, cam, W, H);
          top.push(tp);
          bot.push(bp);
          d += bp[1];
        }
        return { top, bot, d };
      }).sort((a, b) => b.d - a.d).slice(0, 2).sort((a, b) => a.d - b.d);
      for (const s of strips) {
        ctx.beginPath();
        ctx.moveTo(s.top[0][0], s.top[0][1]);
        for (const p of s.top) ctx.lineTo(p[0], p[1]);
        for (let k = s.bot.length - 1; k >= 0; k--) ctx.lineTo(s.bot[k][0], s.bot[k][1]);
        ctx.closePath();
        ctx.fillStyle = mix("#C4C9C1", "#9CA199", 0.55);
        ctx.fill();
        ctx.strokeStyle = "rgba(120,126,118,.3)";
        ctx.lineWidth = 0.5 * DPR;
        ctx.stroke();
      }
      ctx.globalAlpha = 1;
    }
    function drawFoot(W, H, cam, ph) {
      const tile = tileRef.current;
      if (!tile) return;
      const draw = easeOut(smooth(0.95, 1.9, ph));
      const fade = 1 - smooth(2.35, 3, ph);
      if (fade <= 0) return;
      ctx.fillStyle = "#9AA6A8";
      ctx.globalAlpha = fade * 0.8;
      for (const r of tile.water) {
        const ps = ringPts(r, 0, cam, W, H);
        ctx.beginPath();
        ps.forEach((p, j) => j ? ctx.lineTo(p[0], p[1]) : ctx.moveTo(p[0], p[1]));
        ctx.closePath();
        ctx.fill();
      }
      const R = tile.roads;
      for (let i = 0; i < R.length; i++) {
        const seg = clamp(draw * R.length - i, 0, 1);
        if (seg <= 0) continue;
        const rd = R[i];
        ctx.strokeStyle = "#1A1F26";
        ctx.lineWidth = (0.5 + rd.w * 0.5) * DPR * cam.zoom * 2;
        ctx.lineCap = "round";
        ctx.lineJoin = "round";
        ctx.globalAlpha = fade * (rd.w >= 4 ? 0.8 : rd.w >= 3 ? 0.55 : 0.38);
        ctx.beginPath();
        const pts = rd.p, n = pts.length, last = clamp(seg * (n - 1), 0, n - 1), fk = last | 0;
        for (let k = 0; k <= fk; k++) {
          const P = project(pts[k][0], pts[k][1], 0, cam, W, H);
          k ? ctx.lineTo(P[0], P[1]) : ctx.moveTo(P[0], P[1]);
        }
        const ft = last - fk;
        if (ft > 0 && fk + 1 < n) {
          const A = project(pts[fk][0], pts[fk][1], 0, cam, W, H), B2 = project(pts[fk + 1][0], pts[fk + 1][1], 0, cam, W, H);
          ctx.lineTo(lerp(A[0], B2[0], ft), lerp(A[1], B2[1], ft));
        }
        ctx.stroke();
      }
      const B = tile.buildings;
      ctx.strokeStyle = "#1A1F26";
      ctx.lineWidth = DPR;
      for (let i = 0; i < B.length; i++) {
        const seg = clamp(draw * 1.3 - i / B.length, 0, 1);
        if (seg <= 0) continue;
        ctx.globalAlpha = fade * seg;
        const ps = ringPts(B[i].p, 0, cam, W, H);
        ctx.beginPath();
        ps.forEach((p, j) => j ? ctx.lineTo(p[0], p[1]) : ctx.moveTo(p[0], p[1]));
        ctx.closePath();
        ctx.stroke();
      }
      ctx.globalAlpha = 1;
    }
    function drawMesh(W, H, cam, ph) {
      const tile = tileRef.current;
      if (!tile) return;
      const ex = easeOut(smooth(1.95, 3, ph));
      if (ex <= 0) return;
      const seal = smooth(2.55, 3.05, ph);
      const list = tile.buildings.map((b) => {
        const c = cen(b.p);
        const s = project(c[0], c[1], 0, cam, W, H);
        return { b, cu: c[0], cv: c[1], d: s[1] };
      }).sort((p, q) => p.d - q.d);
      for (const it of list) {
        const b = it.b, ground = sampleH(it.cu, it.cv), eh = (0.018 + b.lv * 0.016) * ex, sealed = clamp(seal * 1.2 - it.cv, 0, 1);
        const top = ringPts(b.p, ground + eh, cam, W, H), base = ringPts(b.p, ground, cam, W, H);
        const tone = clamp((b.lv - 1) / 10, 0, 1);
        const face = mix("#F4F5F2", "#C6CBC3", 0.3 + tone * 0.45), side = mix("#CDD2CA", "#9DA39A", 0.3 + tone * 0.5);
        ctx.globalAlpha = clamp(ex * 1.4, 0, 1);
        ctx.strokeStyle = "#C8CDC4";
        ctx.lineWidth = 0.5 * DPR;
        ctx.fillStyle = side;
        for (let i = 0; i < base.length - 1; i++) {
          ctx.beginPath();
          ctx.moveTo(base[i][0], base[i][1]);
          ctx.lineTo(base[i + 1][0], base[i + 1][1]);
          ctx.lineTo(top[i + 1][0], top[i + 1][1]);
          ctx.lineTo(top[i][0], top[i][1]);
          ctx.closePath();
          ctx.fill();
          ctx.stroke();
        }
        ctx.beginPath();
        top.forEach((p, j) => j ? ctx.lineTo(p[0], p[1]) : ctx.moveTo(p[0], p[1]));
        ctx.closePath();
        ctx.fillStyle = face;
        ctx.fill();
        ctx.strokeStyle = "#1A1F26";
        ctx.lineWidth = 0.7 * DPR;
        ctx.globalAlpha = clamp(ex * 1.4, 0, 1) * (0.55 + 0.45 * sealed);
        ctx.stroke();
      }
      if (seal > 0 && seal < 1) {
        const p0 = project(0, seal, 0, cam, W, H), p1 = project(1, seal, 0, cam, W, H);
        ctx.globalAlpha = 0.8;
        ctx.strokeStyle = ACC;
        ctx.lineWidth = 1.6 * DPR;
        ctx.beginPath();
        ctx.moveTo(p0[0], p0[1]);
        ctx.lineTo(p1[0], p1[1]);
        ctx.stroke();
      }
      ctx.globalAlpha = 1;
    }
    function paint() {
      const cw = Math.max(1, Math.round(wrap.clientWidth * DPR));
      const chh = Math.max(1, Math.round(wrap.clientHeight * DPR));
      if (cv.width !== cw || cv.height !== chh) {
        cv.width = cw;
        cv.height = chh;
      }
      const W = cv.width, Hh = cv.height;
      const ph = clamp(pRef.current, 0, 3.999);
      const cam = rig(ph);
      ctx.clearRect(0, 0, W, Hh);
      ctx.fillStyle = ph >= 3.25 ? "#E1E5E0" : "#F7F8F6";
      ctx.fillRect(0, 0, W, Hh);
      const dotA = clamp(1 - smooth(1.15, 1.95, ph), 0, 1);
      const surfA = clamp(smooth(1.25, 2.05, ph), 0, 1);
      const skirtA = clamp(smooth(2.7, 3.6, ph), 0, 1);
      if (skirtA > 2e-3) drawSkirt(W, Hh, cam, ph, skirtA);
      if (surfA > 2e-3) drawSurface(W, Hh, cam, ph, surfA);
      if (dotA > 2e-3) drawDots(W, Hh, cam, ph, dotA);
      if (ph > 0.8 && ph < 3.05) drawFoot(W, Hh, cam, ph);
      if (ph > 1.7 && ph < 3.4) drawMesh(W, Hh, cam, ph);
      const veil = smooth(3.05, 3.2, ph);
      if (veil > 0) {
        ctx.globalAlpha = veil;
        ctx.fillStyle = "#E1E5E0";
        ctx.fillRect(0, 0, W, Hh);
        ctx.globalAlpha = 1;
      }
      raf = requestAnimationFrame(paint);
    }
    raf = requestAnimationFrame(paint);
    return () => {
      cancelAnimationFrame(raf);
      ro.disconnect();
    };
  }, []);
  const SUB = ["ENVIRONMENT AGENCY \xB7 LIDAR", "OPENSTREETMAP \xB7 BUILDINGS, WATER", "WATERTIGHT \xB7 MEASURED ROOFS", "BAMBU LAB \xB7 PLA WHITE \xB7 9 CM"];
  const TXT = ["01 \xB7 LIDAR HEIGHTFIELD", "02 \xB7 OSM FOOTPRINTS", "03 \xB7 WATERTIGHT MESH", "04 \xB7 FINISHED OBJECT"];
  const rawIdx = mode === "off" ? 3 : Math.max(0, Math.min(3, Math.floor(progress * 4 + 1e-4)));
  const idx = rawIdx === 3 && obj3dOpacity < 0.4 ? 2 : rawIdx;
  const label3d = { title: "SHEFFIELD", subline: "", coord: "53.381\xB0 N \xB7 1.470\xB0 W", showCoords: true };
  return /* @__PURE__ */ React.createElement("div", { style: { position: "relative", alignSelf: "stretch", height: "100%", display: "flex", alignItems: "center", justifyContent: "center" } }, /* @__PURE__ */ React.createElement("div", { ref: wrapRef, style: { position: "relative", width: "100%", aspectRatio: "1/1", maxWidth: 560, background: "var(--bone)", border: "1px solid var(--ink)", overflow: "hidden" } }, /* @__PURE__ */ React.createElement("canvas", { ref: canvasRef, style: { width: "100%", height: "100%", display: "block" } }), show3d && /* @__PURE__ */ React.createElement("div", { style: {
    position: "absolute",
    inset: 0,
    background: "var(--mist)",
    opacity: obj3dOpacity,
    transition: "opacity .12s linear",
    pointerEvents: obj3dOpacity > 0.6 ? "auto" : "none"
  } }, /* @__PURE__ */ React.createElement(
    Model3DViewer,
    {
      url: window.cfPaths && window.cfPaths.glb || "assets/products/sheffield.glb",
      fallback: window.cfPaths && window.cfPaths.glbFallback || "assets/products/sheffield_on_base.png",
      label: label3d,
      height: "100%",
      autoRotate: autoRotateNow,
      autoRotateSpeed: -0.6,
      showHint: false
    }
  )), /* @__PURE__ */ React.createElement(StageBadge, { text: TXT[idx], sub: SUB[idx] }), /* @__PURE__ */ React.createElement(CornerMarks, null)));
}
function FeaturedCollection({ items, go }) {
  return /* @__PURE__ */ React.createElement("section", { style: { background: "var(--bone)", borderBottom: "1px solid var(--line)" } }, /* @__PURE__ */ React.createElement("div", { className: "container", style: { paddingTop: 120, paddingBottom: 96 } }, /* @__PURE__ */ React.createElement("div", { style: { display: "flex", justifyContent: "space-between", alignItems: "baseline", marginBottom: 52 } }, /* @__PURE__ */ React.createElement(Reveal, null, /* @__PURE__ */ React.createElement("div", { className: "eyebrow", style: { marginBottom: 18 } }, "FROM THE COLLECTION"), /* @__PURE__ */ React.createElement("h2", { className: "display-section", style: { fontSize: "clamp(56px, 6vw, 84px)" } }, "Six cities,", /* @__PURE__ */ React.createElement("br", null), "six signatures.")), /* @__PURE__ */ React.createElement(Reveal, { delay: 200, style: { maxWidth: 340 } }, /* @__PURE__ */ React.createElement("p", { className: "body", style: { fontSize: 15, lineHeight: 1.6, color: "var(--ink-soft)" } }, "The twelve are paired in six: a city, a landmark, the colour the landmark gives back. Same square, same scale."), /* @__PURE__ */ React.createElement("button", { className: "btn-v2-ghost btn-v2", style: { marginTop: 20 }, onClick: () => go("atlas") }, "See all twelve ", /* @__PURE__ */ React.createElement("span", { className: "btn-arrow" }, Icon.arrow)))), /* @__PURE__ */ React.createElement("div", { style: { display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: 24 } }, items.slice(0, 6).map((item, i) => /* @__PURE__ */ React.createElement(Reveal, { key: item.id, delay: i * 80 }, /* @__PURE__ */ React.createElement(ProductCard, { item, onClick: () => {
    window.location = window.cityformShopify.productUrl(item.slug || item.id);
  } }))))));
}
function TheTwelveGrid({ go }) {
  const twelve = window.CATALOG.filter((c) => c.featured).slice(0, 12);
  return /* @__PURE__ */ React.createElement("section", { style: { background: "var(--ink)", color: "var(--mist)", position: "relative", overflow: "hidden" } }, /* @__PURE__ */ React.createElement("div", { className: "container", style: { paddingTop: 120, paddingBottom: 120, position: "relative" } }, /* @__PURE__ */ React.createElement("div", { style: { textAlign: "center", marginBottom: 72 } }, /* @__PURE__ */ React.createElement(Reveal, null, /* @__PURE__ */ React.createElement("div", { className: "eyebrow", style: { color: "rgba(225,229,224,0.55)", fontSize: 10, marginBottom: 18 } }, "THE TWELVE"), /* @__PURE__ */ React.createElement("h2", { className: "display-section", style: { fontSize: "clamp(56px, 6vw, 96px)", color: "var(--mist)" } }, "One format. Twelve places."), /* @__PURE__ */ React.createElement("p", { className: "body", style: { fontSize: 16, color: "rgba(225,229,224,0.7)", maxWidth: 560, margin: "24px auto 0", lineHeight: 1.6 } }, "Six in production, six in development. Each is a 9\xA0cm crop, scaled to the same 1:11000, printed in PLA\xA0Mist and seated on a graphite base."))), /* @__PURE__ */ React.createElement("div", { style: { display: "grid", gridTemplateColumns: "repeat(4, 1fr)", gap: 24 } }, twelve.map((c, i) => /* @__PURE__ */ React.createElement(Reveal, { key: c.id, delay: i * 50 }, /* @__PURE__ */ React.createElement(
    "button",
    {
      onClick: () => go("product", c.id),
      className: "card-lift",
      style: { display: "block", width: "100%", textAlign: "left", color: "var(--mist)" }
    },
    /* @__PURE__ */ React.createElement("div", { style: {
      aspectRatio: "4/5",
      overflow: "hidden",
      position: "relative",
      background: "#0F1216",
      border: "1px solid rgba(225,229,224,0.18)"
    } }, c.on_base || c.photo ? /* @__PURE__ */ React.createElement(
      "img",
      {
        src: c.on_base || c.photo,
        alt: c.name,
        style: {
          width: "100%",
          height: "100%",
          objectFit: "cover",
          filter: "grayscale(0.35) contrast(1.05) brightness(0.96)"
        }
      }
    ) : /* @__PURE__ */ React.createElement("div", { style: { width: "100%", height: "100%", display: "flex", alignItems: "center", justifyContent: "center" } }, /* @__PURE__ */ React.createElement("span", { className: "eyebrow", style: { color: "rgba(225,229,224,0.45)", fontSize: 9 } }, "AWAITING")), c.status === "soon" && /* @__PURE__ */ React.createElement("div", { style: {
      position: "absolute",
      top: 12,
      left: 12,
      background: "var(--mist)",
      color: "var(--ink)",
      padding: "4px 10px",
      fontSize: 9,
      letterSpacing: "0.22em",
      fontWeight: 500
    } }, "IN DEVELOPMENT"), c.accent && /* @__PURE__ */ React.createElement("div", { style: { position: "absolute", top: 0, left: 0, right: 0, height: 2, background: `var(--${c.accent})` } })),
    /* @__PURE__ */ React.createElement("div", { style: { marginTop: 18, display: "flex", justifyContent: "space-between", alignItems: "baseline" } }, /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("div", { style: { fontSize: 20, fontWeight: 600, letterSpacing: "-0.01em" } }, c.name), /* @__PURE__ */ React.createElement("div", { className: "tnum", style: { marginTop: 6, fontSize: 10, color: "rgba(225,229,224,0.55)" } }, c.coords.lat.toFixed(3), "\xB0", c.coords.ns, " \xB7 ", Math.abs(c.coords.lng).toFixed(3), "\xB0", c.coords.ew)), /* @__PURE__ */ React.createElement("span", { className: "tnum", style: { fontSize: 11, color: "rgba(225,229,224,0.7)" } }, String(i + 1).padStart(2, "0")))
  ))))));
}
function CommissionPreviewV2({ go }) {
  return /* @__PURE__ */ React.createElement("section", { style: { background: "var(--mist)", position: "relative", overflow: "hidden", borderBottom: "1px solid var(--line)" } }, /* @__PURE__ */ React.createElement(OsContourBg, { seed: "commission-bg", density: 9, opacity: 0.12 }), /* @__PURE__ */ React.createElement("div", { className: "container", style: { paddingTop: 120, paddingBottom: 120, position: "relative", zIndex: 2 } }, /* @__PURE__ */ React.createElement("div", { style: { display: "grid", gridTemplateColumns: "1fr 1.1fr", gap: 80, alignItems: "center" } }, /* @__PURE__ */ React.createElement(Reveal, null, /* @__PURE__ */ React.createElement("div", { style: { display: "flex", alignItems: "center", gap: 14, marginBottom: 24 } }, /* @__PURE__ */ React.createElement("span", { style: { width: 48, height: 1, background: "var(--ink)" } }), /* @__PURE__ */ React.createElement("span", { className: "eyebrow", style: { fontSize: 10 } }, "COMMISSION")), /* @__PURE__ */ React.createElement("h2", { className: "display-section", style: { fontSize: "clamp(56px, 6.5vw, 100px)", marginBottom: 32 } }, "Your place,", /* @__PURE__ */ React.createElement("br", null), "your square kilometre."), /* @__PURE__ */ React.createElement("p", { className: "body", style: { fontSize: 17, lineHeight: 1.6, color: "var(--ink-soft)", maxWidth: 500 } }, "The childhood street. The summit you've climbed twenty times. The hospital where they were born. Anywhere on the map, on the same system as the twelve."), /* @__PURE__ */ React.createElement("div", { style: { marginTop: 36, display: "grid", gap: 18 } }, [
    ["Free preview", "See your area in plan view before you spend a penny."],
    ["Same system", "9 \xD7 9 cm, 1:11000, white PLA on a graphite base."],
    ["Eight-week turnaround", "Printed, finished, photographed and shipped from Sheffield."]
  ].map(([title, d]) => /* @__PURE__ */ React.createElement("div", { key: title, style: { display: "flex", gap: 16, alignItems: "flex-start" } }, /* @__PURE__ */ React.createElement("span", { style: { marginTop: 4, color: "var(--ink)" } }, Icon.check), /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("div", { style: { fontWeight: 600, fontSize: 15.5 } }, title), /* @__PURE__ */ React.createElement("div", { className: "body", style: { fontSize: 14, color: "var(--stone)", marginTop: 2 } }, d))))), /* @__PURE__ */ React.createElement("button", { className: "btn-v2", style: { marginTop: 40 }, onClick: () => go("atelier") }, "Start with a postcode ", /* @__PURE__ */ React.createElement("span", { className: "btn-arrow" }, Icon.arrow))), /* @__PURE__ */ React.createElement(Reveal, { kind: "reveal-clip", delay: 200 }, /* @__PURE__ */ React.createElement("div", { style: { position: "relative", border: "1px solid var(--ink)", height: 560, background: "var(--bone)" } }, /* @__PURE__ */ React.createElement(StyledMap, { seed: "sheffield-preview", bbox: { x: 30, y: 30, w: 38, h: 38, r: 0 } }), /* @__PURE__ */ React.createElement("div", { style: {
    position: "absolute",
    top: 22,
    left: 22,
    right: 22,
    display: "flex",
    alignItems: "center",
    gap: 10,
    padding: "14px 18px",
    background: "var(--bone)",
    border: "1px solid var(--ink)"
  } }, Icon.search, /* @__PURE__ */ React.createElement("span", { style: { fontSize: 14, fontWeight: 500 } }, "S1 2HE \u2014 Sheffield City Hall"), /* @__PURE__ */ React.createElement("span", { style: { marginLeft: "auto" }, className: "caption" }, "53.3811\xB0 N \xB7 1.4701\xB0 W")), /* @__PURE__ */ React.createElement("div", { style: {
    position: "absolute",
    bottom: 22,
    left: 22,
    right: 22,
    padding: "14px 18px",
    background: "var(--bone)",
    border: "1px solid var(--ink)",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between"
  } }, /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("div", { className: "eyebrow", style: { fontSize: 9 } }, "PREVIEW AREA"), /* @__PURE__ */ React.createElement("div", { style: { fontSize: 14, fontWeight: 600, marginTop: 6, letterSpacing: "-0.005em" } }, "Sheffield City Centre \xB7 1.00 \xD7 1.00 km")), /* @__PURE__ */ React.createElement("button", { className: "btn-v2", style: { height: 40, padding: "0 16px", fontSize: 11.5 }, onClick: () => go("atelier") }, "Open picker ", /* @__PURE__ */ React.createElement("span", { className: "btn-arrow" }, Icon.arrow))), /* @__PURE__ */ React.createElement(CornerMarks, null))))));
}
function ARShelfModule({ handle }) {
  const cfp = typeof window !== "undefined" && window.cfPaths || {};
  const prod = cfp.products && cfp.products[handle || "sheffield-citycentre"] || cfp.products && cfp.products["sheffield-citycentre"] || null;
  const arUrl = prod && prod.usdz || null;
  const qrUrl = prod && prod.qr || null;
  const arLabel = prod ? prod.subline ? `${prod.title} \xB7 ${prod.subline} \xB7 9 CM` : `${prod.title} \xB7 9 CM` : "SHEFFIELD \xB7 9 CM";
  const qr = /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 33 33", width: "100%", height: "100%", shapeRendering: "crispEdges" }, /* @__PURE__ */ React.createElement("rect", { width: "33", height: "33", fill: "var(--bone)" }), Array.from({ length: 33 * 33 }).map((_, i) => {
    const x = i % 33, y = Math.floor(i / 33);
    const seed = (x * 71 + y * 113 + x * y * 17) % 7;
    if (x < 7 && y < 7 || x > 25 && y < 7 || x < 7 && y > 25) {
      const inFinder = x >= 1 && x <= 5 && y >= 1 && y <= 5;
      const innerDot = x >= 2 && x <= 4 && y >= 2 && y <= 4;
      if (inFinder && !innerDot) return null;
      if ((x === 0 || x === 6 || y === 0 || y === 6) && (x < 7 && y < 7)) return /* @__PURE__ */ React.createElement("rect", { key: i, x, y, width: "1", height: "1", fill: "var(--ink)" });
      if (innerDot) return /* @__PURE__ */ React.createElement("rect", { key: i, x, y, width: "1", height: "1", fill: "var(--ink)" });
      if ((x === 26 || x === 32 || y === 0 || y === 6) && (x > 25 && y < 7)) return /* @__PURE__ */ React.createElement("rect", { key: i, x, y, width: "1", height: "1", fill: "var(--ink)" });
      if (x >= 28 && x <= 30 && y >= 2 && y <= 4) return /* @__PURE__ */ React.createElement("rect", { key: i, x, y, width: "1", height: "1", fill: "var(--ink)" });
      if ((x === 0 || x === 6 || y === 26 || y === 32) && (x < 7 && y > 25)) return /* @__PURE__ */ React.createElement("rect", { key: i, x, y, width: "1", height: "1", fill: "var(--ink)" });
      if (x >= 2 && x <= 4 && y >= 28 && y <= 30) return /* @__PURE__ */ React.createElement("rect", { key: i, x, y, width: "1", height: "1", fill: "var(--ink)" });
      return null;
    }
    return seed < 2 ? /* @__PURE__ */ React.createElement("rect", { key: i, x, y, width: "1", height: "1", fill: "var(--ink)" }) : null;
  }));
  return /* @__PURE__ */ React.createElement("section", { style: { background: "var(--bone)", borderTop: "1px solid var(--line)", borderBottom: "1px solid var(--line)" } }, /* @__PURE__ */ React.createElement("div", { className: "container", style: { paddingTop: 108, paddingBottom: 108 } }, /* @__PURE__ */ React.createElement("div", { style: { display: "grid", gridTemplateColumns: "1.1fr 1fr", gap: 80, alignItems: "center" } }, /* @__PURE__ */ React.createElement(Reveal, null, /* @__PURE__ */ React.createElement("div", { style: { display: "flex", alignItems: "center", gap: 14, marginBottom: 22 } }, /* @__PURE__ */ React.createElement("span", { style: { width: 48, height: 1, background: "var(--ink)" } }), /* @__PURE__ */ React.createElement("span", { className: "eyebrow", style: { fontSize: 10 } }, "AR \xB7 NO APP REQUIRED")), /* @__PURE__ */ React.createElement("h2", { className: "display-section", style: { fontSize: "clamp(56px, 6.2vw, 96px)", marginBottom: 28 } }, "See it on your shelf,", /* @__PURE__ */ React.createElement("br", null), "before you order."), /* @__PURE__ */ React.createElement("p", { className: "body", style: { fontSize: 17, lineHeight: 1.6, color: "var(--ink-soft)", maxWidth: 520 } }, "Scan with the iPhone Camera. Safari opens AR Quick Look and places the model at ", /* @__PURE__ */ React.createElement("strong", null, "true 9\xA0cm"), " on any flat surface. Walk around it. Move it. See whether it lives on the mantelpiece or the desk."), /* @__PURE__ */ React.createElement("div", { style: { marginTop: 36, display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: 18 } }, [
    ["01", "Point Camera", "Open Camera, point at the code."],
    ["02", "Tap to open", "Safari opens the AR preview."],
    ["03", "Place it", "Tap on a surface to place at 9 cm."]
  ].map(([n, t, d]) => /* @__PURE__ */ React.createElement("div", { key: n, style: { borderTop: "1px solid var(--ink)", paddingTop: 14 } }, /* @__PURE__ */ React.createElement("div", { className: "tnum", style: { fontSize: 11, fontWeight: 600, letterSpacing: "0.18em" } }, n), /* @__PURE__ */ React.createElement("div", { style: { marginTop: 6, fontWeight: 600, fontSize: 15 } }, t), /* @__PURE__ */ React.createElement("div", { className: "body", style: { marginTop: 6, fontSize: 12.5, color: "var(--stone)", lineHeight: 1.55 } }, d)))), /* @__PURE__ */ React.createElement("div", { style: {
    marginTop: 32,
    padding: "14px 18px",
    background: "var(--mist)",
    borderLeft: "2px solid var(--ink)",
    fontSize: 12.5,
    color: "var(--ink)",
    lineHeight: 1.55
  } }, /* @__PURE__ */ React.createElement("strong", null, "iPhone only."), " Android AR Core in development \u2014 on Android the same scan opens a high-res 3D preview, no AR placement yet.")), /* @__PURE__ */ React.createElement(Reveal, { kind: "reveal-clip", delay: 200 }, /* @__PURE__ */ React.createElement("div", { style: { position: "relative", display: "flex", alignItems: "center", justifyContent: "center", minHeight: 600 } }, /* @__PURE__ */ React.createElement("div", { style: {
    width: 280,
    aspectRatio: "9/19",
    position: "relative",
    background: "#0F1216",
    borderRadius: 36,
    padding: 10,
    boxShadow: "0 50px 80px -40px rgba(0,0,0,0.4)"
  } }, /* @__PURE__ */ React.createElement("div", { style: {
    width: "100%",
    height: "100%",
    borderRadius: 26,
    background: "var(--mist)",
    position: "relative",
    overflow: "hidden"
  } }, /* @__PURE__ */ React.createElement(
    "img",
    {
      src: window.cfAssets && window.cfAssets["sheffield_on_base.png"] || "assets/products/sheffield_on_base.png",
      alt: "AR preview",
      style: { width: "100%", height: "100%", objectFit: "cover" }
    }
  ), /* @__PURE__ */ React.createElement("div", { style: { position: "absolute", inset: 0, display: "flex", flexDirection: "column", justifyContent: "space-between", padding: 14 } }, /* @__PURE__ */ React.createElement("div", { style: { display: "flex", justifyContent: "space-between" } }, /* @__PURE__ */ React.createElement("span", { style: { background: "rgba(15,18,22,0.7)", color: "#fff", fontSize: 9, letterSpacing: "0.22em", fontWeight: 500, padding: "3px 8px" } }, "AR \xB7 LIVE"), /* @__PURE__ */ React.createElement("span", { style: { background: "rgba(15,18,22,0.7)", color: "#fff", fontSize: 9, fontWeight: 500, padding: "3px 8px", fontVariantNumeric: "tabular-nums" } }, "9.0 CM")), /* @__PURE__ */ React.createElement("div", { style: { position: "absolute", left: "50%", top: "62%", transform: "translate(-50%, -50%)" } }, /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 200 200", width: "160", height: "160", style: { opacity: 0.8 } }, /* @__PURE__ */ React.createElement("ellipse", { cx: "100", cy: "100", rx: "90", ry: "20", fill: "none", stroke: "#fff", strokeWidth: "1.5", strokeDasharray: "6 4" }), /* @__PURE__ */ React.createElement("ellipse", { cx: "100", cy: "100", rx: "70", ry: "14", fill: "none", stroke: "#fff", strokeWidth: "1", opacity: "0.6" }), /* @__PURE__ */ React.createElement("circle", { cx: "100", cy: "100", r: "2", fill: "#fff" }))), /* @__PURE__ */ React.createElement("div", { style: { display: "flex", justifyContent: "center", gap: 14 } }, /* @__PURE__ */ React.createElement("span", { style: { width: 38, height: 38, borderRadius: "50%", background: "rgba(255,255,255,0.92)", display: "flex", alignItems: "center", justifyContent: "center" } }, /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", width: "18", height: "18", fill: "none", stroke: "#000", strokeWidth: "1.8" }, /* @__PURE__ */ React.createElement("path", { d: "M12 5v14M5 12h14" }))))))), /* @__PURE__ */ React.createElement(
    "a",
    {
      href: arUrl || "#",
      rel: arUrl ? "ar" : void 0,
      onClick: arUrl ? void 0 : (e) => e.preventDefault(),
      style: {
        position: "absolute",
        left: "4%",
        bottom: "18%",
        background: "var(--mist)",
        border: "1px solid var(--ink)",
        padding: 14,
        width: 188,
        textDecoration: "none",
        color: "inherit",
        cursor: arUrl ? "pointer" : "default"
      }
    },
    /* @__PURE__ */ React.createElement("div", { className: "eyebrow", style: { fontSize: 9 } }, arUrl ? "SCAN \xB7 OR TAP" : "SCAN \xB7 TO SEE IT"),
    /* @__PURE__ */ React.createElement("div", { style: { marginTop: 10, width: "100%", aspectRatio: "1/1" } }, qrUrl ? /* @__PURE__ */ React.createElement(
      "img",
      {
        src: qrUrl,
        alt: "Scan with iPhone camera to view in AR",
        style: { width: "100%", height: "100%", objectFit: "contain" }
      }
    ) : qr),
    /* @__PURE__ */ React.createElement("div", { className: "tnum", style: { marginTop: 10, fontSize: 9, color: "var(--stone)", letterSpacing: "0.18em" } }, arLabel)
  ), /* @__PURE__ */ React.createElement("div", { style: {
    position: "absolute",
    right: "2%",
    top: "14%",
    background: "var(--bone)",
    border: "1px solid var(--ink)",
    padding: "10px 14px"
  } }, /* @__PURE__ */ React.createElement("div", { className: "eyebrow", style: { fontSize: 9 } }, "TRUE TO SCALE"), /* @__PURE__ */ React.createElement("div", { className: "tnum", style: { marginTop: 6, fontSize: 13, fontWeight: 600 } }, "1 : 1"), /* @__PURE__ */ React.createElement("div", { className: "tnum", style: { marginTop: 2, fontSize: 10, color: "var(--stone)" } }, "placed at 9 cm")))))));
}
function PullQuoteV2() {
  return /* @__PURE__ */ React.createElement("section", { style: { background: "var(--mist)", borderBottom: "1px solid var(--line)" } }, /* @__PURE__ */ React.createElement("div", { className: "container", style: { paddingTop: 128, paddingBottom: 128, textAlign: "center", position: "relative" } }, /* @__PURE__ */ React.createElement(Reveal, null, /* @__PURE__ */ React.createElement("span", { className: "eyebrow", style: { display: "block", marginBottom: 36 } }, "WHAT PEOPLE SAY"), /* @__PURE__ */ React.createElement("p", { className: "pull-quote", style: {
    fontSize: "clamp(40px, 4.6vw, 72px)",
    maxWidth: 1100,
    margin: "0 auto",
    color: "var(--ink)"
  } }, '"Felt like opening an Ordnance Survey map and finding it had been pressed into ', /* @__PURE__ */ React.createElement("em", null, "three\xA0dimensions"), '."'), /* @__PURE__ */ React.createElement("div", { style: { marginTop: 48, display: "flex", alignItems: "center", justifyContent: "center", gap: 18 } }, /* @__PURE__ */ React.createElement("span", { style: { width: 36, height: 1, background: "var(--ink)" } }), /* @__PURE__ */ React.createElement("span", { className: "eyebrow", style: { fontSize: 10 } }, "THE GEOGRAPHER QUARTERLY \xB7 SPRING 2026"), /* @__PURE__ */ React.createElement("span", { style: { width: 36, height: 1, background: "var(--ink)" } })))));
}
function ArchiveSection({ items, go }) {
  return /* @__PURE__ */ React.createElement("section", { style: { background: "var(--bone)", borderBottom: "1px solid var(--line)" } }, /* @__PURE__ */ React.createElement("div", { className: "container", style: { paddingTop: 120, paddingBottom: 96 } }, /* @__PURE__ */ React.createElement("div", { style: { display: "flex", justifyContent: "space-between", alignItems: "baseline", marginBottom: 48 } }, /* @__PURE__ */ React.createElement(Reveal, null, /* @__PURE__ */ React.createElement("div", { className: "eyebrow", style: { marginBottom: 18 } }, "FROM THE STUDIO ARCHIVE"), /* @__PURE__ */ React.createElement("h2", { className: "display-section", style: { fontSize: "clamp(48px, 5vw, 72px)" } }, "Recent commissions.")), /* @__PURE__ */ React.createElement(Reveal, { delay: 120 }, /* @__PURE__ */ React.createElement("button", { className: "btn-v2 btn-v2-ghost", onClick: () => go("atlas") }, "See the archive ", /* @__PURE__ */ React.createElement("span", { className: "btn-arrow" }, Icon.arrow)))), /* @__PURE__ */ React.createElement("div", { style: { display: "grid", gridTemplateColumns: "repeat(4, 1fr)", gap: 24 } }, items.map((item, i) => /* @__PURE__ */ React.createElement(Reveal, { key: item.id, delay: i * 80 }, /* @__PURE__ */ React.createElement(ProductCard, { item, onClick: () => {
    window.location = window.cityformShopify.productUrl(item.slug || item.id);
  } }))))));
}
function PressStripV2() {
  const quotes = [
    { q: '"You can find your own front door."', a: "Iona Galloway \xB7 Architect, Glasgow" },
    { q: '"Mine is a square kilometre of Hampstead Heath. It looks like a fossil."', a: "Dev Patel \xB7 London" },
    { q: '"The detail is unreasonable \u2014 and exactly right."', a: "Studio Notes \xB7 April 2026" }
  ];
  return /* @__PURE__ */ React.createElement("section", { style: { background: "var(--mist)" } }, /* @__PURE__ */ React.createElement("div", { className: "container", style: { paddingTop: 96, paddingBottom: 96 } }, /* @__PURE__ */ React.createElement("div", { className: "eyebrow", style: { textAlign: "center", marginBottom: 48 } }, "FIELD NOTES FROM READERS"), /* @__PURE__ */ React.createElement("div", { style: { display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: 48 } }, quotes.map((p, i) => /* @__PURE__ */ React.createElement(Reveal, { key: i, delay: i * 100 }, /* @__PURE__ */ React.createElement("div", { style: { borderTop: "1px solid var(--ink)", paddingTop: 22 } }, /* @__PURE__ */ React.createElement("p", { style: { fontSize: 22, lineHeight: 1.4, fontWeight: 500, letterSpacing: "-0.005em" } }, p.q), /* @__PURE__ */ React.createElement("div", { className: "eyebrow", style: { marginTop: 22, fontSize: 9 } }, p.a)))))));
}
const _ATLAS_PROJ_X = (lng) => (lng + 7) * 67;
const _ATLAS_PROJ_Y = (lat) => (58.8 - lat) * 81;
const _UK_OUTLINE_PATH = "M 397.6 656.9 L 392.0 659.7 L 390.2 663.0 L 388.9 664.3 L 385.2 665.1 L 381.5 665.1 L 367.5 658.5 L 364.3 658.8 L 367.4 655.8 L 376.1 653.4 L 381.0 650.1 L 392.3 653.3 L 397.6 656.9 Z M 187.8 443.8 L 190.6 445.3 L 197.7 445.0 L 195.4 448.4 L 187.6 452.1 L 182.3 455.8 L 176.0 458.9 L 172.9 455.4 L 169.4 455.5 L 163.9 448.7 L 163.0 438.5 L 170.1 435.8 L 179.9 436.0 L 187.8 443.8 Z M 52.4 381.6 L 46.7 381.1 L 42.6 382.6 L 40.0 383.9 L 37.5 383.6 L 30.3 384.2 L 23.5 384.0 L 22.5 381.9 L 23.7 375.6 L 22.1 373.8 L 15.6 373.0 L 13.2 371.4 L 9.5 367.0 L 8.8 365.0 L 8.2 362.1 L 4.3 358.5 L -0.5 355.9 L -3.3 355.7 L -8.9 360.0 L -13.6 364.4 L -11.9 366.5 L -10.4 369.4 L -12.9 371.5 L -20.6 376.2 L -21.7 378.0 L -23.8 379.0 L -27.4 377.7 L -36.5 378.0 L -40.6 377.1 L -45.5 373.7 L -57.3 371.4 L -59.3 365.8 L -61.5 364.8 L -74.9 355.2 L -76.7 352.1 L -75.0 350.2 L -70.0 347.3 L -53.2 342.5 L -50.5 340.6 L -50.0 338.9 L -54.9 337.0 L -59.4 334.8 L -60.9 333.4 L -58.5 330.7 L -53.4 330.5 L -49.4 331.3 L -46.2 329.8 L -40.6 328.4 L -36.9 326.6 L -33.6 321.9 L -30.2 317.8 L -29.9 315.5 L -26.9 307.5 L -25.3 305.6 L -14.6 300.3 L -12.0 303.2 L -6.7 303.9 L -2.1 301.3 L 3.5 293.0 L 7.4 292.5 L 11.7 293.2 L 20.2 292.1 L 35.2 288.3 L 41.9 288.2 L 51.3 290.2 L 58.3 290.2 L 64.6 296.1 L 68.0 305.4 L 75.8 314.6 L 86.0 322.6 L 86.4 327.5 L 82.7 330.1 L 75.1 333.4 L 75.1 336.9 L 80.2 335.1 L 84.5 334.3 L 95.0 335.1 L 98.6 338.6 L 101.2 343.9 L 102.5 348.3 L 101.6 353.0 L 98.8 351.5 L 95.9 347.3 L 92.7 345.3 L 89.0 344.3 L 90.7 350.1 L 90.1 357.9 L 91.7 358.6 L 96.6 358.7 L 93.3 366.7 L 86.6 368.9 L 78.6 369.7 L 76.7 372.5 L 75.3 376.2 L 71.2 381.6 L 65.7 384.6 L 59.0 384.0 L 52.4 381.6 Z M 126.9 271.4 L 118.5 271.5 L 115.4 270.8 L 111.8 268.8 L 107.7 257.7 L 109.2 253.8 L 110.8 251.9 L 112.7 250.4 L 117.1 249.7 L 121.6 251.8 L 123.3 253.8 L 127.0 261.3 L 127.7 267.8 L 126.9 271.4 Z M 58.4 232.4 L 60.8 242.8 L 63.1 249.3 L 63.3 251.5 L 61.1 254.5 L 50.0 258.6 L 46.6 258.6 L 48.9 253.5 L 46.8 248.8 L 47.8 245.2 L 44.6 245.1 L 36.7 250.8 L 34.1 251.3 L 35.7 245.5 L 36.0 242.3 L 37.2 240.4 L 39.3 238.6 L 41.9 237.2 L 43.9 237.0 L 46.1 238.4 L 52.5 234.5 L 58.4 232.4 Z M 69.0 241.8 L 67.6 242.7 L 64.2 242.5 L 63.0 241.1 L 62.3 239.1 L 62.2 235.5 L 64.2 232.8 L 72.9 228.8 L 69.0 227.4 L 71.1 223.1 L 80.4 218.0 L 82.9 217.1 L 85.4 217.2 L 80.6 226.3 L 69.0 241.8 Z M 81.9 198.9 L 55.2 203.4 L 46.0 203.0 L 45.2 200.8 L 47.0 199.3 L 54.6 197.9 L 57.7 187.1 L 46.2 182.1 L 45.6 180.7 L 46.5 178.3 L 47.8 177.2 L 54.8 174.7 L 57.7 174.2 L 60.1 174.5 L 65.0 177.4 L 70.6 183.5 L 78.0 184.5 L 83.0 187.1 L 81.9 198.9 Z M 26.3 179.4 L 22.5 179.9 L 28.8 173.2 L 33.1 172.3 L 34.6 172.9 L 31.5 176.0 L 26.3 179.4 Z M 48.3 148.7 L 46.3 149.7 L 43.8 149.5 L 41.3 148.2 L 38.0 144.3 L 45.4 141.7 L 48.4 143.3 L 49.5 145.0 L 49.5 147.0 L 48.3 148.7 Z M 57.3 104.9 L 57.2 108.5 L 56.0 112.7 L 57.6 117.2 L 57.9 120.3 L 60.7 121.4 L 62.5 122.8 L 75.0 124.5 L 86.7 124.0 L 88.9 125.3 L 89.2 127.4 L 87.4 129.7 L 80.7 133.9 L 72.8 140.7 L 70.4 142.1 L 67.9 142.2 L 66.0 141.6 L 64.7 129.5 L 56.1 131.0 L 49.2 130.9 L 45.4 129.4 L 42.7 126.6 L 37.4 119.3 L 21.7 116.4 L 17.3 112.4 L 16.0 110.0 L 19.8 105.6 L 23.9 106.7 L 26.4 106.1 L 27.9 104.7 L 25.8 101.0 L 41.6 96.9 L 43.0 91.8 L 46.5 91.4 L 50.5 93.1 L 55.9 98.4 L 57.3 104.9 Z M 53.7 35.4 L 45.2 49.5 L 41.8 49.8 L 38.9 53.4 L 29.8 57.3 L 37.8 57.4 L 40.0 58.7 L 40.0 61.5 L 38.5 63.1 L 28.3 69.6 L 21.2 72.0 L 13.6 78.8 L 9.8 78.9 L 6.0 83.2 L 2.9 85.0 L 1.1 85.0 L -0.9 84.1 L -5.6 79.9 L 3.0 75.7 L 3.7 73.4 L 9.6 71.0 L -0.2 66.8 L -3.8 64.5 L 1.0 60.7 L -1.1 60.4 L -2.6 58.9 L -5.2 58.4 L -5.9 57.1 L -6.4 53.6 L -5.7 50.0 L -3.0 48.5 L -1.9 46.8 L 3.4 47.2 L 7.6 50.0 L 12.6 48.9 L 18.3 49.5 L 14.2 41.8 L 15.0 40.4 L 17.3 38.7 L 30.5 33.8 L 47.1 25.4 L 51.1 24.1 L 52.3 25.2 L 54.0 29.6 L 53.7 35.4 Z M 260.7 23.0 L 261.2 29.7 L 260.4 31.7 L 258.8 34.2 L 253.8 38.8 L 240.5 45.4 L 216.1 60.6 L 201.7 68.1 L 199.7 71.7 L 198.6 76.8 L 207.2 77.8 L 210.6 79.5 L 208.5 82.1 L 195.7 91.0 L 192.0 99.0 L 201.8 98.7 L 209.8 97.2 L 225.9 92.2 L 241.0 88.4 L 248.3 88.3 L 262.4 91.2 L 265.6 91.3 L 271.6 90.0 L 277.6 89.7 L 318.6 90.7 L 330.0 88.9 L 337.6 91.0 L 343.9 96.2 L 349.9 105.8 L 349.7 107.4 L 346.1 111.8 L 339.4 117.3 L 333.6 124.8 L 332.0 128.9 L 330.8 133.4 L 329.0 137.5 L 317.6 156.9 L 306.4 167.6 L 301.4 175.2 L 295.3 181.3 L 289.4 185.1 L 283.1 187.7 L 264.8 190.4 L 259.7 192.4 L 253.6 195.7 L 247.2 197.4 L 254.7 197.1 L 262.2 195.3 L 275.7 194.6 L 291.3 201.0 L 289.8 206.3 L 283.6 210.4 L 269.4 211.1 L 256.1 220.3 L 250.1 223.1 L 243.7 224.6 L 235.8 224.1 L 221.4 221.7 L 215.1 219.1 L 220.8 223.3 L 227.3 225.5 L 264.7 230.7 L 267.0 230.2 L 278.9 224.7 L 294.8 224.6 L 325.1 234.7 L 333.9 242.4 L 346.4 253.4 L 353.2 257.7 L 358.1 261.6 L 361.1 267.5 L 367.0 286.8 L 373.7 305.7 L 382.5 326.1 L 386.4 331.8 L 391.7 335.8 L 418.1 344.9 L 424.0 348.0 L 434.3 356.8 L 444.2 366.2 L 453.4 373.4 L 463.3 379.2 L 458.5 382.3 L 455.2 387.0 L 457.7 393.5 L 461.7 399.7 L 469.7 409.6 L 476.7 420.4 L 474.1 418.8 L 471.4 417.9 L 467.7 418.2 L 464.1 417.7 L 457.4 414.3 L 450.9 410.1 L 438.1 411.8 L 431.0 411.0 L 424.8 411.2 L 436.5 413.6 L 449.3 413.7 L 477.6 431.9 L 487.2 442.6 L 492.8 456.8 L 489.0 463.2 L 482.9 467.4 L 477.3 472.1 L 472.1 477.4 L 487.7 485.3 L 491.1 485.1 L 494.6 484.0 L 497.9 481.3 L 503.5 474.8 L 506.4 472.5 L 516.2 471.6 L 524.4 472.1 L 532.6 473.6 L 539.7 473.1 L 554.2 475.9 L 561.6 478.4 L 580.0 489.7 L 584.0 495.9 L 585.8 503.9 L 586.0 512.8 L 582.9 520.9 L 579.4 528.2 L 577.2 537.7 L 575.6 541.1 L 573.5 543.8 L 563.7 551.2 L 557.2 554.3 L 554.5 552.9 L 551.6 553.1 L 551.3 554.9 L 554.3 558.7 L 554.4 563.3 L 548.6 566.7 L 542.8 568.2 L 533.0 566.4 L 519.4 572.7 L 529.2 576.0 L 531.1 579.4 L 528.7 585.5 L 522.5 588.2 L 515.7 589.4 L 508.8 589.7 L 503.0 591.2 L 497.4 594.1 L 504.4 592.6 L 509.2 593.9 L 512.2 599.0 L 515.0 600.5 L 528.6 602.7 L 537.0 602.7 L 553.2 601.4 L 561.0 601.4 L 563.8 602.4 L 563.8 606.6 L 562.6 617.1 L 560.5 619.2 L 539.0 628.0 L 534.6 634.1 L 533.3 637.8 L 520.7 637.1 L 514.9 641.1 L 504.7 643.7 L 496.8 646.4 L 489.1 649.9 L 482.7 651.0 L 455.3 646.8 L 438.8 647.2 L 416.4 650.8 L 410.6 650.2 L 402.0 646.7 L 393.1 644.4 L 382.9 643.4 L 374.1 640.2 L 379.6 646.3 L 367.4 652.3 L 361.7 653.4 L 355.9 653.3 L 344.0 654.9 L 332.9 654.0 L 334.6 658.3 L 337.5 661.9 L 335.1 663.6 L 332.6 664.0 L 311.5 661.2 L 308.6 661.7 L 306.0 664.3 L 298.3 662.9 L 290.9 658.6 L 282.9 655.6 L 274.6 654.3 L 268.0 654.8 L 240.9 661.6 L 235.5 668.4 L 232.8 678.1 L 228.8 686.7 L 222.5 693.4 L 214.8 694.2 L 207.7 689.6 L 194.1 684.6 L 189.4 681.1 L 186.4 682.2 L 181.1 683.7 L 175.6 683.8 L 167.1 685.2 L 152.2 689.3 L 146.2 692.1 L 133.4 699.8 L 130.7 701.9 L 126.1 709.7 L 118.9 711.1 L 112.4 706.1 L 104.9 704.3 L 97.1 706.0 L 92.3 708.7 L 90.1 706.5 L 90.0 702.1 L 95.8 696.8 L 111.1 692.9 L 124.5 682.5 L 131.1 676.2 L 133.7 672.7 L 136.9 670.4 L 141.1 669.6 L 143.3 665.7 L 161.9 649.9 L 163.5 646.3 L 164.4 639.8 L 166.0 633.6 L 181.1 629.6 L 188.4 616.5 L 190.4 615.5 L 211.6 613.1 L 227.3 613.3 L 242.9 615.8 L 250.9 616.1 L 258.9 615.2 L 265.2 611.7 L 276.0 598.9 L 282.0 593.3 L 289.0 588.3 L 295.5 582.5 L 306.0 571.8 L 298.9 575.5 L 290.3 581.3 L 285.3 584.7 L 269.4 588.2 L 262.6 591.6 L 250.7 599.5 L 248.4 600.2 L 230.3 598.3 L 216.9 588.1 L 208.3 583.9 L 204.8 583.4 L 201.1 584.6 L 193.3 585.9 L 185.3 585.7 L 189.4 581.0 L 194.9 578.3 L 182.5 576.5 L 179.0 575.1 L 175.1 571.8 L 165.4 571.2 L 160.7 572.1 L 152.9 576.4 L 140.5 581.1 L 125.6 574.6 L 122.7 571.8 L 122.8 566.3 L 120.6 562.0 L 116.4 560.5 L 121.7 554.9 L 128.1 551.1 L 142.1 547.4 L 163.4 538.6 L 175.3 534.8 L 186.4 528.3 L 191.0 524.4 L 194.3 519.0 L 197.6 512.3 L 202.3 506.9 L 197.8 505.6 L 195.7 501.6 L 196.3 497.4 L 198.4 493.8 L 196.5 489.2 L 193.1 484.4 L 193.3 480.6 L 194.2 476.6 L 185.6 476.9 L 177.1 478.1 L 169.4 480.9 L 161.9 484.8 L 155.2 485.5 L 155.3 482.4 L 158.2 478.6 L 165.8 473.2 L 173.9 468.7 L 176.7 465.3 L 179.0 461.3 L 183.0 458.1 L 193.6 452.1 L 213.8 445.3 L 216.8 444.9 L 224.7 445.7 L 232.5 444.6 L 239.3 442.2 L 246.1 441.7 L 261.5 448.7 L 256.9 437.8 L 263.7 435.2 L 273.5 445.1 L 277.1 446.1 L 284.8 444.7 L 281.8 443.0 L 278.4 442.9 L 273.8 441.4 L 270.0 438.3 L 263.7 428.3 L 264.0 422.3 L 268.3 416.1 L 273.0 410.4 L 269.1 409.3 L 265.9 407.1 L 265.0 401.4 L 266.2 396.4 L 274.7 392.0 L 277.2 385.2 L 278.3 377.8 L 276.9 374.4 L 268.4 375.0 L 264.3 376.4 L 260.7 378.6 L 256.9 378.4 L 246.5 370.2 L 240.5 364.0 L 229.9 350.9 L 228.3 343.1 L 236.9 326.2 L 250.0 315.4 L 265.6 311.6 L 262.6 310.9 L 238.9 310.7 L 231.1 312.1 L 223.9 316.5 L 219.8 317.8 L 215.5 318.3 L 211.6 320.5 L 207.8 323.6 L 203.8 325.5 L 195.9 325.0 L 192.1 325.7 L 189.3 323.9 L 187.0 321.0 L 184.0 320.2 L 180.7 321.1 L 173.5 325.0 L 166.3 327.4 L 157.6 324.9 L 146.2 320.3 L 143.9 322.0 L 141.4 326.2 L 139.9 333.0 L 131.8 327.1 L 124.9 319.3 L 122.6 314.4 L 122.4 308.9 L 126.2 306.8 L 130.3 308.8 L 136.3 295.7 L 148.4 278.7 L 152.7 273.7 L 155.7 267.2 L 155.1 262.9 L 152.5 259.3 L 141.2 251.2 L 141.4 244.5 L 142.6 237.0 L 145.7 232.5 L 146.9 231.6 L 161.9 231.8 L 156.0 229.4 L 144.4 222.7 L 144.7 220.3 L 147.4 214.0 L 143.6 217.5 L 138.9 224.5 L 136.0 226.2 L 127.8 227.8 L 126.3 231.3 L 125.0 232.2 L 120.9 232.6 L 119.6 235.8 L 117.5 232.5 L 117.4 226.8 L 119.1 221.5 L 122.2 217.3 L 134.2 207.9 L 128.4 210.8 L 115.1 219.5 L 108.3 225.2 L 106.5 227.2 L 105.9 228.8 L 106.0 230.7 L 109.0 240.8 L 108.1 245.4 L 96.7 276.2 L 94.6 279.3 L 92.6 281.0 L 90.7 281.3 L 85.0 280.7 L 82.5 278.4 L 82.6 275.8 L 83.6 271.9 L 88.3 257.3 L 90.4 253.2 L 93.5 249.4 L 100.2 242.8 L 95.6 243.7 L 93.6 243.2 L 92.3 241.9 L 93.2 222.3 L 96.8 215.9 L 98.2 206.5 L 101.3 198.4 L 105.0 192.6 L 107.7 185.1 L 111.9 181.8 L 113.0 176.7 L 117.7 171.2 L 121.4 165.4 L 119.4 166.0 L 96.2 181.0 L 90.3 183.7 L 82.2 183.0 L 76.1 181.3 L 71.2 177.7 L 69.1 170.9 L 63.1 170.7 L 58.0 169.6 L 64.7 164.9 L 75.2 163.6 L 85.0 157.7 L 76.3 153.7 L 84.7 149.0 L 94.4 137.5 L 96.4 127.0 L 91.7 122.0 L 90.0 118.7 L 80.7 115.1 L 79.2 110.5 L 80.3 107.9 L 83.3 105.4 L 87.9 103.4 L 95.0 101.5 L 88.5 99.5 L 86.1 97.1 L 84.3 93.7 L 84.1 91.7 L 87.5 82.8 L 89.4 79.1 L 93.2 74.4 L 110.6 74.7 L 112.6 72.6 L 114.6 72.5 L 123.5 74.4 L 122.1 72.4 L 107.6 61.3 L 106.3 59.2 L 110.5 53.2 L 110.8 50.5 L 110.2 47.6 L 111.3 45.5 L 115.9 44.4 L 130.0 44.5 L 133.4 43.5 L 131.9 40.6 L 128.6 36.8 L 128.0 33.7 L 128.7 30.8 L 128.9 25.2 L 129.5 22.7 L 132.9 18.9 L 135.6 17.8 L 139.0 17.1 L 146.8 18.4 L 149.7 19.9 L 153.1 23.5 L 155.6 23.2 L 165.2 19.3 L 168.0 18.8 L 172.0 23.3 L 188.4 19.7 L 210.4 18.1 L 223.7 15.7 L 237.6 14.8 L 250.6 12.1 L 264.4 13.4 L 264.9 14.9 L 264.2 17.1 L 260.7 23.0 Z M 272.7 4.7 L 269.6 3.5 L 265.6 -1.8 L 271.9 -2.9 L 274.9 -2.2 L 273.8 0.0 L 272.7 4.7 Z M 256.9 0.5 L 253.1 1.5 L 249.3 1.5 L 243.4 -3.2 L 241.1 -6.6 L 241.6 -8.9 L 244.1 -9.6 L 249.8 -8.5 L 252.7 -4.6 L 253.1 -2.1 L 257.4 -0.1 L 256.9 0.5 Z M -14.6 300.3 L -25.3 305.6 L -26.9 307.5 L -29.9 315.5 L -30.2 317.8 L -33.6 321.9 L -36.9 326.6 L -40.6 328.4 L -46.2 329.8 L -49.4 331.3 L -53.4 330.5 L -58.5 330.7 L -61.0 332.2 L -59.4 334.8 L -54.9 337.0 L -50.0 338.9 L -50.5 340.6 L -53.2 342.5 L -70.0 347.3 L -75.0 350.2 L -76.7 352.1 L -74.9 355.2 L -61.5 364.8 L -59.3 365.8 L -57.3 371.4 L -45.5 373.7 L -40.6 377.1 L -36.5 378.0 L -27.4 377.7 L -23.8 379.0 L -21.7 378.0 L -20.6 376.2 L -12.9 371.5 L -10.4 369.4 L -11.9 366.5 L -13.6 364.4 L -8.9 360.0 L -3.3 355.7 L -0.5 355.9 L 4.3 358.5 L 8.2 362.1 L 8.8 365.0 L 9.5 367.0 L 13.2 371.4 L 15.6 373.0 L 22.1 373.8 L 23.7 375.6 L 22.5 381.9 L 23.5 384.0 L 30.3 384.2 L 37.5 383.6 L 40.0 383.9 L 42.6 382.6 L 46.7 381.1 L 52.4 381.6 L 55.2 384.5 L 56.5 387.4 L 51.5 388.5 L 46.4 387.9 L 43.9 389.8 L 43.7 393.6 L 45.5 398.3 L 48.9 401.7 L 51.7 409.4 L 53.9 417.9 L 57.5 423.0 L 58.2 429.4 L 57.7 432.5 L 58.4 438.1 L 56.8 440.1 L 58.0 445.4 L 62.2 456.3 L 64.0 462.4 L 65.2 475.7 L 62.2 480.7 L 58.2 485.4 L 55.7 491.0 L 53.7 497.1 L 52.4 506.8 L 43.9 518.2 L 40.2 521.1 L 36.0 522.8 L 45.2 530.8 L 37.7 534.4 L 29.4 535.5 L 20.3 533.5 L 14.6 533.7 L 9.4 536.3 L 7.4 537.9 L 5.7 537.1 L 2.3 530.6 L -0.2 537.4 L -5.5 539.5 L -14.5 539.1 L -29.5 540.9 L -35.3 542.8 L -37.7 545.8 L -39.5 549.3 L -41.9 551.4 L -44.5 552.4 L -56.1 555.0 L -58.4 556.0 L -63.8 561.7 L -70.9 564.9 L -76.7 565.9 L -81.9 562.6 L -84.0 560.7 L -86.4 559.7 L -94.4 559.8 L -91.9 560.8 L -90.3 563.1 L -89.5 567.6 L -90.4 571.9 L -94.3 574.1 L -99.0 574.5 L -106.4 579.0 L -116.2 580.3 L -121.5 584.4 L -153.9 591.4 L -155.7 591.5 L -160.2 589.7 L -165.0 588.9 L -169.8 589.5 L -183.4 593.4 L -190.0 592.6 L -181.6 582.9 L -170.3 578.0 L -169.2 576.6 L -172.8 576.0 L -194.2 579.4 L -201.7 582.3 L -209.1 583.1 L -205.7 578.7 L -196.1 572.6 L -190.9 569.7 L -187.8 568.6 L -184.2 565.0 L -174.1 561.0 L -206.6 569.3 L -215.2 568.3 L -217.2 566.0 L -223.9 567.1 L -226.4 561.4 L -216.5 552.9 L -210.8 549.2 L -204.0 547.2 L -197.4 544.3 L -194.9 540.8 L -198.0 539.7 L -217.7 540.6 L -227.1 539.9 L -226.6 537.1 L -224.9 534.0 L -215.1 528.8 L -209.8 528.0 L -205.1 528.4 L -200.5 529.8 L -196.8 531.6 L -185.7 530.5 L -190.4 527.2 L -191.2 520.4 L -194.7 518.1 L -190.2 514.9 L -185.0 513.0 L -176.4 506.5 L -173.3 505.5 L -156.2 503.9 L -137.8 500.5 L -119.5 495.7 L -128.9 493.1 L -133.3 489.6 L -140.6 496.7 L -145.8 499.4 L -160.4 500.8 L -165.1 500.0 L -171.6 497.8 L -173.6 498.7 L -175.5 500.4 L -185.2 503.8 L -195.4 504.7 L -183.6 498.3 L -168.5 487.5 L -165.1 484.1 L -160.4 478.2 L -161.9 475.6 L -165.0 474.1 L -154.0 461.9 L -150.2 459.7 L -143.2 459.3 L -138.1 457.4 L -135.8 457.4 L -133.8 456.7 L -129.3 453.0 L -136.2 450.7 L -143.4 449.5 L -165.5 450.8 L -168.5 450.5 L -171.2 449.4 L -173.0 447.8 L -174.3 443.6 L -175.9 442.7 L -180.9 442.7 L -185.9 444.0 L -189.3 443.9 L -192.7 442.0 L -187.3 437.8 L -194.2 436.8 L -201.3 437.6 L -207.1 436.4 L -207.3 433.7 L -204.6 431.1 L -208.1 428.5 L -208.8 425.4 L -205.1 423.8 L -201.1 424.3 L -192.8 422.0 L -182.3 420.8 L -191.3 418.5 L -195.0 416.5 L -195.1 413.5 L -194.4 410.9 L -183.9 406.5 L -172.7 404.6 L -173.6 401.7 L -172.8 398.5 L -184.1 397.6 L -195.2 399.8 L -194.0 393.9 L -191.4 388.5 L -190.8 384.9 L -191.4 381.1 L -196.6 382.7 L -197.2 377.3 L -199.5 373.6 L -207.2 376.2 L -207.0 371.3 L -204.8 367.9 L -200.7 366.4 L -196.7 367.1 L -189.2 367.0 L -182.0 364.5 L -171.7 363.8 L -155.1 364.6 L -143.8 371.8 L -140.8 370.5 L -136.3 366.0 L -134.2 365.5 L -117.0 367.5 L -106.4 370.1 L -103.6 369.3 L -105.1 364.2 L -108.8 360.7 L -104.1 356.1 L -98.6 353.0 L -94.8 351.5 L -86.2 349.5 L -82.4 347.7 L -79.9 341.8 L -75.9 336.9 L -97.6 339.4 L -118.2 333.6 L -114.9 329.5 L -110.6 327.2 L -103.1 325.4 L -102.4 323.2 L -98.6 321.4 L -92.3 316.8 L -94.6 310.6 L -93.3 306.1 L -88.8 303.2 L -87.4 299.0 L -85.4 296.0 L -76.2 294.8 L -67.4 292.0 L -64.2 292.3 L -53.8 291.6 L -50.3 292.8 L -51.1 287.7 L -44.7 287.0 L -42.2 288.0 L -41.1 291.6 L -38.2 293.9 L -37.3 297.9 L -39.2 301.0 L -42.5 303.3 L -39.5 305.8 L -44.1 310.2 L -39.2 308.3 L -32.1 304.0 L -32.4 300.5 L -33.6 296.1 L -35.6 292.1 L -34.7 287.7 L -30.7 285.0 L -20.2 283.6 L -24.5 278.6 L -20.7 278.2 L -16.5 279.2 L -10.4 283.1 L -4.0 286.1 L 2.6 288.5 L -3.8 293.4 L -11.6 296.7 L -14.6 300.3 Z";
function AtlasHome() {
  const cfp = typeof window !== "undefined" && window.cfPaths || {};
  const products = cfp.products || {};
  const photos = cfp.productPhotos || {};
  const cities = Object.keys(products).map((handle) => {
    const p = products[handle];
    const name = p.subline ? `${p.title} \xB7 ${p.subline}` : p.title;
    return {
      id: handle,
      name,
      coords: {
        lat: p.lat,
        lng: p.lng,
        ns: p.lat >= 0 ? "N" : "S",
        ew: p.lng >= 0 ? "E" : "W"
      },
      photo: photos[handle],
      price: 45
    };
  }).filter((c) => Number.isFinite(c.coords.lat) && Number.isFinite(c.coords.lng));
  const [activeId, setActiveId] = React.useState(cities[0] && cities[0].id);
  if (cities.length === 0) return null;
  const active = cities.find((c) => c.id === activeId) || cities[0];
  const ax = _ATLAS_PROJ_X(active.coords.lng);
  const ay = _ATLAS_PROJ_Y(active.coords.lat);
  const px = ax / 600 * 100;
  const py = ay / 760 * 100;
  const flipX = px > 55;
  const flipY = py > 50;
  const popupStyle = {
    left: flipX ? "auto" : `${px + 3}%`,
    right: flipX ? `${100 - px + 3}%` : "auto",
    top: flipY ? "auto" : `${py - 6}%`,
    bottom: flipY ? `${100 - py + 4}%` : "auto"
  };
  return /* @__PURE__ */ React.createElement("section", { style: { background: "var(--bone)", borderBottom: "1px solid var(--line)" } }, /* @__PURE__ */ React.createElement("div", { className: "container", style: { paddingTop: 96, paddingBottom: 96 } }, /* @__PURE__ */ React.createElement("div", { style: {
    display: "grid",
    gridTemplateColumns: "160px 1fr auto",
    gap: 48,
    alignItems: "flex-end",
    paddingBottom: 56,
    borderBottom: "1px solid var(--ink)",
    marginBottom: 48
  } }, /* @__PURE__ */ React.createElement("div", { className: "eyebrow", style: { paddingBottom: 8 } }, "\xA7 02 \xB7 The Atlas"), /* @__PURE__ */ React.createElement("h2", { className: "display-section", style: { fontSize: "clamp(48px, 5vw, 64px)" } }, "Plates,", /* @__PURE__ */ React.createElement("br", null), /* @__PURE__ */ React.createElement("em", { className: "serif-accent", style: { color: "var(--ink-soft)" } }, "located.")), /* @__PURE__ */ React.createElement("div", { style: { textAlign: "right", fontSize: 10, letterSpacing: "0.24em", textTransform: "uppercase", color: "var(--stone)", lineHeight: 1.6, paddingBottom: 8 } }, /* @__PURE__ */ React.createElement("strong", { style: { color: "var(--ink)", fontWeight: 500, display: "block" } }, "9 \xD7 9 cm \xB7 1:11000"), /* @__PURE__ */ React.createElement("span", null, "\xA345 each \xB7 made to order"), /* @__PURE__ */ React.createElement("span", { style: { display: "block", marginTop: 8 } }, cities.length, " ", cities.length === 1 ? "plate" : "plates", " in stock"))), /* @__PURE__ */ React.createElement("div", { style: { display: "grid", gridTemplateColumns: "280px 1fr 320px", gap: 48, alignItems: "start" } }, /* @__PURE__ */ React.createElement("aside", { style: { position: "sticky", top: 96 } }, /* @__PURE__ */ React.createElement("div", { className: "eyebrow", style: { marginBottom: 10 } }, "Read the map"), /* @__PURE__ */ React.createElement("h3", { style: { fontSize: 24, fontWeight: 600, lineHeight: 1.1, letterSpacing: "-0.012em", margin: "0 0 14px" } }, "Every plate is a place we\u2019ve been."), /* @__PURE__ */ React.createElement("p", { style: { fontSize: 13.5, lineHeight: 1.6, color: "var(--ink-soft)", margin: "0 0 20px" } }, "Hover a pin to see the plate. Each one is a square kilometre of LIDAR, cut to the same 9\xA0\xD7\xA09\xA0cm format and finished with a single engraved label.")), /* @__PURE__ */ React.createElement("div", { style: { position: "relative", background: "var(--surface-2)", border: "1px solid var(--ink)", minHeight: 680, overflow: "hidden" } }, /* @__PURE__ */ React.createElement(
    "svg",
    {
      viewBox: "0 0 600 760",
      preserveAspectRatio: "xMidYMid meet",
      xmlns: "http://www.w3.org/2000/svg",
      style: { display: "block", width: "100%", height: "auto" },
      "aria-label": `UK map with ${cities.length} plates`
    },
    /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("pattern", { id: "atlas-grid", width: "48", height: "48", patternUnits: "userSpaceOnUse" }, /* @__PURE__ */ React.createElement("path", { d: "M 48 0 L 0 0 0 48", fill: "none", stroke: "rgba(26,31,38,0.06)", strokeWidth: "1" }))),
    /* @__PURE__ */ React.createElement("rect", { width: "100%", height: "100%", fill: "var(--surface-2)" }),
    /* @__PURE__ */ React.createElement("rect", { width: "100%", height: "100%", fill: "url(#atlas-grid)" }),
    /* @__PURE__ */ React.createElement("g", { fontSize: "9", fill: "var(--stone)", fontFamily: "Inter, sans-serif", letterSpacing: "2" }, /* @__PURE__ */ React.createElement("text", { x: "10", y: "14" }, "58\xB0 N"), /* @__PURE__ */ React.createElement("text", { x: "10", y: "14", dy: "240" }, "56\xB0"), /* @__PURE__ */ React.createElement("text", { x: "10", y: "14", dy: "480" }, "54\xB0"), /* @__PURE__ */ React.createElement("text", { x: "10", y: "14", dy: "720" }, "50\xB0"), /* @__PURE__ */ React.createElement("text", { x: "540", y: "752" }, "2\xB0 E"), /* @__PURE__ */ React.createElement("text", { x: "240", y: "752" }, "4\xB0 W"), /* @__PURE__ */ React.createElement("text", { x: "60", y: "752" }, "7\xB0 W")),
    /* @__PURE__ */ React.createElement("g", { fill: "var(--bone)", stroke: "var(--line-strong)", strokeWidth: "1.1", strokeLinejoin: "round" }, /* @__PURE__ */ React.createElement("path", { d: _UK_OUTLINE_PATH })),
    cities.map((c) => {
      const x = _ATLAS_PROJ_X(c.coords.lng);
      const y = _ATLAS_PROJ_Y(c.coords.lat);
      const isActive = c.id === activeId;
      return /* @__PURE__ */ React.createElement(
        "g",
        {
          key: c.id,
          transform: `translate(${x} ${y})`,
          style: { cursor: "pointer" },
          onMouseEnter: () => setActiveId(c.id),
          onClick: () => window.cfGo("product", c.id)
        },
        isActive && /* @__PURE__ */ React.createElement("rect", { x: "-8.5", y: "-8.5", width: "17", height: "17", fill: "none", stroke: c.accent ? `var(--${c.accent})` : "var(--vermilion)", strokeWidth: "1.2" }),
        /* @__PURE__ */ React.createElement("rect", { x: "-3.5", y: "-3.5", width: "7", height: "7", fill: "var(--ink)" }),
        isActive && /* @__PURE__ */ React.createElement(
          "text",
          {
            x: "10",
            y: "3.5",
            fontSize: "9.5",
            letterSpacing: "2",
            fill: "var(--ink)",
            fontFamily: "Inter, sans-serif",
            fontWeight: "600"
          },
          c.name.toUpperCase()
        )
      );
    })
  ), /* @__PURE__ */ React.createElement("div", { style: {
    position: "absolute",
    width: 264,
    background: "var(--bone)",
    border: "1px solid var(--ink)",
    boxShadow: "0 24px 48px -24px rgba(0,0,0,0.22)",
    zIndex: 5,
    transition: "left .2s, right .2s, top .2s, bottom .2s",
    ...popupStyle
  } }, /* @__PURE__ */ React.createElement("div", { style: { height: 128, background: "var(--plate-navy)", position: "relative", overflow: "hidden" } }, (active.on_base || active.photo) && /* @__PURE__ */ React.createElement(
    "img",
    {
      src: active.on_base || active.photo,
      alt: "",
      style: { position: "absolute", inset: 0, width: "100%", height: "100%", objectFit: "cover" }
    }
  ), active.accent && /* @__PURE__ */ React.createElement("span", { style: { position: "absolute", right: 12, top: 12, width: 10, height: 10, background: `var(--${active.accent})` } })), /* @__PURE__ */ React.createElement("div", { style: { padding: "16px 18px" } }, /* @__PURE__ */ React.createElement("div", { style: { display: "flex", justifyContent: "space-between", alignItems: "baseline" } }, /* @__PURE__ */ React.createElement("div", { style: { fontSize: 18, fontWeight: 600, letterSpacing: "-0.005em" } }, active.name), /* @__PURE__ */ React.createElement("div", { className: "tnum", style: { fontSize: 13, fontWeight: 500 } }, "\xA3", active.price || 45)), /* @__PURE__ */ React.createElement("div", { className: "tnum", style: { fontSize: 10, color: "var(--stone)", letterSpacing: "0.18em", textTransform: "uppercase", marginTop: 6 } }, active.coords.lat.toFixed(3), "\xB0 ", active.coords.ns, " \xB7 ", Math.abs(active.coords.lng).toFixed(3), "\xB0 ", active.coords.ew), /* @__PURE__ */ React.createElement(
    "button",
    {
      onClick: () => window.cfGo("product", active.id),
      style: {
        marginTop: 14,
        paddingTop: 12,
        borderTop: "1px solid var(--ink)",
        width: "100%",
        textAlign: "left",
        fontSize: 11,
        letterSpacing: "0.22em",
        textTransform: "uppercase",
        fontWeight: 500,
        color: "var(--ink)",
        background: "none",
        cursor: "pointer",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center"
      }
    },
    /* @__PURE__ */ React.createElement("span", null, "Open the plate"),
    /* @__PURE__ */ React.createElement("span", null, "\u2192")
  )))), /* @__PURE__ */ React.createElement("aside", { style: { position: "sticky", top: 96 } }, /* @__PURE__ */ React.createElement("div", { className: "eyebrow", style: { marginBottom: 14 } }, "Index of plates"), /* @__PURE__ */ React.createElement("ul", { style: { margin: 0, padding: 0, listStyle: "none", borderTop: "1px solid var(--ink)" } }, cities.map((c, i) => /* @__PURE__ */ React.createElement(
    "li",
    {
      key: c.id,
      onMouseEnter: () => setActiveId(c.id),
      onClick: () => window.cfGo("product", c.id),
      style: {
        display: "grid",
        gridTemplateColumns: "18px 1fr 50px",
        gap: 12,
        alignItems: "center",
        padding: "10px 0",
        borderBottom: "1px solid var(--line)",
        cursor: "pointer",
        background: c.id === activeId ? "var(--surface-2)" : "transparent",
        transition: "background .15s"
      }
    },
    /* @__PURE__ */ React.createElement("span", { className: "tnum", style: { fontSize: 10, color: "var(--stone)", letterSpacing: "0.18em" } }, String(i + 1).padStart(2, "0")),
    /* @__PURE__ */ React.createElement("span", { style: { fontSize: 14, fontWeight: 500, letterSpacing: "-0.005em" } }, c.accent && /* @__PURE__ */ React.createElement("span", { style: { display: "inline-block", width: 6, height: 6, background: `var(--${c.accent})`, marginRight: 6, verticalAlign: "middle" } }), c.name),
    /* @__PURE__ */ React.createElement("span", { className: "tnum", style: { fontSize: 11, color: "var(--ink-soft)", textAlign: "right" } }, "\xA3", c.price || 45)
  )))))));
}
const _PB_PHASES = [
  { num: "01", name: "Survey", text: "Environment Agency LIDAR + OpenStreetMap. 1 km\xB2 at 1 m resolution." },
  { num: "02", name: "Print", text: "White SLA topography, printed in one piece at 1:11000." },
  { num: "03", name: "Cast", text: "9 \xD7 9 cm ribbed plinth, cast and CNC-finished in Sheffield." },
  { num: "04", name: "Engrave", text: "Single aluminium-look plate, laser-engraved with the canonical name + coords." }
];
const _PB_CUBOIDS = [
  [0, -4, 26],
  [-30, -2, 18],
  [28, 4, 22],
  [-52, 10, 12],
  [56, 8, 14],
  [-16, 18, 10],
  [18, 20, 16],
  [-40, 26, 22],
  [44, 24, 12],
  [2, 32, 8],
  [-64, 0, 9],
  [68, -2, 10],
  [-22, -16, 14],
  [24, -14, 11],
  [-8, -28, 8],
  [12, 44, 14],
  [-28, 44, 10],
  [36, 40, 7],
  [-50, -16, 9],
  [52, -18, 8]
];
function _PBCuboid({ cx, cy, h }) {
  const s = 7, sy = 4;
  const tp = `M ${cx} ${cy - sy * 2 - h} L ${cx + s * 2} ${cy - sy - h} L ${cx} ${cy - h} L ${cx - s * 2} ${cy - sy - h} Z`;
  const fl = `M ${cx - s * 2} ${cy - sy - h} L ${cx} ${cy - h} L ${cx} ${cy + sy} L ${cx - s * 2} ${cy - sy} Z`;
  const fr = `M ${cx} ${cy - h} L ${cx + s * 2} ${cy - sy - h} L ${cx + s * 2} ${cy - sy} L ${cx} ${cy + sy} Z`;
  return /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("path", { d: fl, fill: "#E5E7E3", stroke: "#1A1F26", strokeWidth: "0.5" }), /* @__PURE__ */ React.createElement("path", { d: fr, fill: "#CDD0CB", stroke: "#1A1F26", strokeWidth: "0.5" }), /* @__PURE__ */ React.createElement("path", { d: tp, fill: "#FBFBFA", stroke: "#1A1F26", strokeWidth: "0.5" }));
}
function ProcessBuild() {
  const [phase, setPhase] = React.useState(0);
  const [paused, setPaused] = React.useState(false);
  React.useEffect(() => {
    if (paused) return;
    const t = setInterval(() => setPhase((p) => (p + 1) % 4), 3400);
    return () => clearInterval(t);
  }, [paused, phase]);
  const cx = 400, cy = 280, D = 40;
  const topRhombus = `M ${cx} ${cy - 60} L ${cx + 160} ${cy} L ${cx} ${cy + 60} L ${cx - 160} ${cy} Z`;
  const flFace = `M ${cx - 160} ${cy} L ${cx} ${cy + 60} L ${cx} ${cy + 60 + D} L ${cx - 160} ${cy + D} Z`;
  const frFace = `M ${cx} ${cy + 60} L ${cx + 160} ${cy} L ${cx + 160} ${cy + D} L ${cx} ${cy + 60 + D} Z`;
  return /* @__PURE__ */ React.createElement(
    "section",
    {
      style: { background: "var(--mist)", borderBottom: "1px solid var(--line)" },
      onMouseLeave: () => setPaused(false)
    },
    /* @__PURE__ */ React.createElement("div", { className: "container", style: { paddingTop: 96, paddingBottom: 120 } }, /* @__PURE__ */ React.createElement("div", { style: {
      display: "grid",
      gridTemplateColumns: "160px 1fr auto",
      gap: 48,
      alignItems: "flex-end",
      paddingBottom: 56,
      borderBottom: "1px solid var(--ink)",
      marginBottom: 48
    } }, /* @__PURE__ */ React.createElement("div", { className: "eyebrow", style: { paddingBottom: 8 } }, "\xA7 04 \xB7 How it\u2019s made"), /* @__PURE__ */ React.createElement("h2", { className: "display-section", style: { fontSize: "clamp(48px, 5vw, 64px)" } }, "A square kilometre,", /* @__PURE__ */ React.createElement("br", null), /* @__PURE__ */ React.createElement("em", { className: "serif-accent", style: { color: "var(--ink-soft)" } }, "cast in 14 hours.")), /* @__PURE__ */ React.createElement("div", { style: { textAlign: "right", fontSize: 10, letterSpacing: "0.24em", textTransform: "uppercase", color: "var(--stone)", lineHeight: 1.6, paddingBottom: 8 } }, /* @__PURE__ */ React.createElement("strong", { style: { color: "var(--ink)", fontWeight: 500, display: "block" } }, "Four phases \xB7 one plinth \xB7 one label"), /* @__PURE__ */ React.createElement("span", null, "Made in Sheffield"))), /* @__PURE__ */ React.createElement("div", { style: { position: "relative", aspectRatio: "16/9", background: "var(--bone)", border: "1px solid var(--ink)", overflow: "hidden" } }, /* @__PURE__ */ React.createElement("div", { style: { position: "absolute", top: 18, left: 20, zIndex: 5, fontSize: 10, letterSpacing: "0.28em", textTransform: "uppercase", color: "var(--stone)" } }, /* @__PURE__ */ React.createElement("strong", { style: { color: "var(--ink)", fontWeight: 500 } }, "Phase ", _PB_PHASES[phase].num), /* @__PURE__ */ React.createElement("span", { style: { display: "block", marginTop: 4 } }, _PB_PHASES[phase].name.toUpperCase())), /* @__PURE__ */ React.createElement("div", { className: "tnum", style: { position: "absolute", top: 18, right: 20, zIndex: 5, fontSize: 10, letterSpacing: "0.28em", textTransform: "uppercase", color: "var(--stone)" } }, String(phase + 1).padStart(2, "0"), " / 04"), /* @__PURE__ */ React.createElement(
      "svg",
      {
        viewBox: "0 0 800 500",
        preserveAspectRatio: "xMidYMid meet",
        xmlns: "http://www.w3.org/2000/svg",
        style: { position: "absolute", inset: 0, width: "100%", height: "100%" }
      },
      /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("pattern", { id: "pb-grid", width: "40", height: "40", patternUnits: "userSpaceOnUse" }, /* @__PURE__ */ React.createElement("path", { d: "M 40 0 L 0 0 0 40", fill: "none", stroke: "rgba(26,31,38,0.045)", strokeWidth: "1" }))),
      /* @__PURE__ */ React.createElement("rect", { width: "100%", height: "100%", fill: "url(#pb-grid)" }),
      /* @__PURE__ */ React.createElement("g", { stroke: "var(--ink)", strokeWidth: "1", opacity: "0.4" }, /* @__PURE__ */ React.createElement("path", { d: "M 30 30 L 60 30 M 30 30 L 30 60" }), /* @__PURE__ */ React.createElement("path", { d: "M 770 30 L 740 30 M 770 30 L 770 60" }), /* @__PURE__ */ React.createElement("path", { d: "M 30 470 L 60 470 M 30 470 L 30 440" }), /* @__PURE__ */ React.createElement("path", { d: "M 770 470 L 740 470 M 770 470 L 770 440" })),
      /* @__PURE__ */ React.createElement(
        "g",
        {
          style: { opacity: phase === 0 ? 1 : phase === 1 ? 0.45 : 0, transition: "opacity .8s ease" },
          fill: "none",
          stroke: "var(--ink)",
          strokeWidth: "0.9"
        },
        /* @__PURE__ */ React.createElement("ellipse", { cx: cx - 12, cy, rx: "142", ry: "48" }),
        /* @__PURE__ */ React.createElement("ellipse", { cx: cx - 6, cy: cy - 2, rx: "110", ry: "38" }),
        /* @__PURE__ */ React.createElement("ellipse", { cx: cx - 2, cy: cy - 4, rx: "80", ry: "28" }),
        /* @__PURE__ */ React.createElement("ellipse", { cx: cx + 4, cy: cy - 6, rx: "52", ry: "18" }),
        /* @__PURE__ */ React.createElement("ellipse", { cx: cx + 8, cy: cy - 8, rx: "24", ry: "8" }),
        /* @__PURE__ */ React.createElement(
          "path",
          {
            d: `M ${cx - 150} ${cy + 8} Q ${cx - 80} ${cy - 12}, ${cx - 10} ${cy + 4} T ${cx + 150} ${cy - 6}`,
            strokeWidth: "1.2",
            stroke: "var(--cobalt)",
            opacity: "0.6"
          }
        ),
        /* @__PURE__ */ React.createElement("path", { d: topRhombus, stroke: "var(--ink)", strokeWidth: "0.6", strokeDasharray: "3 4", opacity: "0.6" })
      ),
      /* @__PURE__ */ React.createElement("g", { style: { opacity: phase >= 2 ? 1 : 0, transition: "opacity .8s ease" } }, /* @__PURE__ */ React.createElement("path", { d: flFace, fill: "#1A1F26" }), /* @__PURE__ */ React.createElement("path", { d: frFace, fill: "#2E343C" }), /* @__PURE__ */ React.createElement("g", { stroke: "rgba(214,217,210,0.18)", strokeWidth: "0.6" }, Array.from({ length: 18 }, (_, i) => {
        const t = (i + 0.5) / 18;
        const x = cx - 160 + t * 160;
        return /* @__PURE__ */ React.createElement("line", { key: "l" + i, x1: x, y1: cy + t * 60, x2: x, y2: cy + t * 60 + D });
      }), Array.from({ length: 18 }, (_, i) => {
        const t = (i + 0.5) / 18;
        const x = cx + t * 160;
        return /* @__PURE__ */ React.createElement("line", { key: "r" + i, x1: x, y1: cy + 60 - t * 60, x2: x, y2: cy + 60 - t * 60 + D });
      })), /* @__PURE__ */ React.createElement("path", { d: topRhombus, fill: "#F7F8F6", stroke: "#1A1F26", strokeWidth: "1" })),
      /* @__PURE__ */ React.createElement("g", { style: { opacity: phase >= 1 ? 1 : 0, transition: "opacity .8s ease" } }, _PB_CUBOIDS.map(([x, y, h], i) => /* @__PURE__ */ React.createElement(_PBCuboid, { key: i, cx: cx + x, cy: cy + y, h }))),
      /* @__PURE__ */ React.createElement("g", { style: { opacity: phase >= 3 ? 1 : 0, transition: "opacity .8s ease" } }, /* @__PURE__ */ React.createElement(
        "rect",
        {
          x: cx - 100,
          y: cy + 78,
          width: "120",
          height: "20",
          rx: "10",
          fill: "var(--plate-pearl)",
          stroke: "#1A1F26",
          strokeWidth: "0.6",
          transform: `skewY(-20.5 ${cx - 100} ${cy + 78})`
        }
      ), /* @__PURE__ */ React.createElement(
        "rect",
        {
          x: cx - 95,
          y: cy + 81,
          width: "110",
          height: "14",
          rx: "7",
          fill: "var(--plate-navy)",
          transform: `skewY(-20.5 ${cx - 95} ${cy + 81})`
        }
      ), /* @__PURE__ */ React.createElement(
        "text",
        {
          x: cx - 86,
          y: cy + 91.5,
          transform: `skewY(-20.5 ${cx - 86} ${cy + 91.5})`,
          fontSize: "6.5",
          letterSpacing: "1.4",
          fill: "var(--plate-pearl)",
          fontFamily: "Inter, sans-serif",
          fontWeight: "600"
        },
        "SHEFFIELD"
      ), /* @__PURE__ */ React.createElement(
        "text",
        {
          x: cx - 32,
          y: cy + 91.5,
          transform: `skewY(-20.5 ${cx - 32} ${cy + 91.5})`,
          fontSize: "5",
          letterSpacing: "0.8",
          fill: "var(--plate-pearl)",
          fontFamily: "Inter, sans-serif",
          opacity: "0.85"
        },
        "53.381\xB0 N"
      )),
      /* @__PURE__ */ React.createElement("g", { fill: "var(--stone)", fontFamily: "Inter, sans-serif", fontSize: "9", letterSpacing: "2" }, /* @__PURE__ */ React.createElement("text", { x: "40", y: "60" }, "SHEFFIELD CITY CENTRE \u2014 1 KM\xB2"), /* @__PURE__ */ React.createElement("text", { x: "40", y: "76" }, "1:11000"), /* @__PURE__ */ React.createElement("text", { x: "708", y: "60", textAnchor: "end" }, "9 \xD7 9 CM"), /* @__PURE__ */ React.createElement("text", { x: "708", y: "76", textAnchor: "end" }, "ABS \xB7 LASER \xB7 INK"))
    )), /* @__PURE__ */ React.createElement("ol", { style: {
      margin: "0",
      padding: 0,
      listStyle: "none",
      display: "grid",
      gridTemplateColumns: "repeat(4, 1fr)",
      border: "1px solid var(--ink)",
      borderTop: 0,
      background: "var(--bone)"
    } }, _PB_PHASES.map((p, i) => /* @__PURE__ */ React.createElement(
      "li",
      {
        key: p.num,
        onMouseEnter: () => {
          setPhase(i);
          setPaused(true);
        },
        onClick: () => {
          setPhase(i);
          setPaused(true);
        },
        style: {
          padding: "24px 22px",
          borderRight: i < 3 ? "1px solid var(--line)" : "0",
          cursor: "pointer",
          background: i === phase ? "var(--ink)" : "transparent",
          color: i === phase ? "var(--bone)" : "var(--ink)",
          transition: "background .2s, color .2s",
          display: "flex",
          flexDirection: "column",
          gap: 8
        }
      },
      /* @__PURE__ */ React.createElement("div", { style: { fontSize: 10, letterSpacing: "0.28em", color: i === phase ? "var(--plate-pearl)" : "var(--stone)" } }, p.num, " \xB7 phase"),
      /* @__PURE__ */ React.createElement("div", { style: { fontSize: 22, fontWeight: 600, letterSpacing: "-0.012em", lineHeight: 1 } }, p.name),
      /* @__PURE__ */ React.createElement("div", { style: { fontSize: 12.5, lineHeight: 1.5, color: i === phase ? "var(--plate-pearl)" : "var(--ink-soft)", maxWidth: "38ch" } }, p.text)
    ))))
  );
}
function ProductModel3D({ handle, fallback }) {
  const wrapRef = React.useRef(null);
  const [inView, setInView] = React.useState(false);
  React.useEffect(() => {
    const el = wrapRef.current;
    if (!el || typeof IntersectionObserver === "undefined") {
      setInView(true);
      return;
    }
    const obs = new IntersectionObserver((entries) => {
      if (entries.some((e) => e.isIntersecting)) {
        setInView(true);
        obs.disconnect();
      }
    }, { rootMargin: "200px 0px" });
    obs.observe(el);
    return () => obs.disconnect();
  }, []);
  const [liveLabel, setLiveLabel] = React.useState(null);
  React.useEffect(() => {
    if (typeof window === "undefined") return;
    function onChange(e) {
      if (!e || !e.detail) return;
      if (e.detail.handle && e.detail.handle !== handle) return;
      setLiveLabel({
        title: e.detail.title || "",
        subline: e.detail.subline || "",
        coord: e.detail.coord || "",
        showCoords: e.detail.showCoords !== false
      });
    }
    window.addEventListener("cf:label-change", onChange);
    return () => window.removeEventListener("cf:label-change", onChange);
  }, [handle]);
  const cfp = typeof window !== "undefined" && window.cfPaths || {};
  const prod = cfp.products && cfp.products[handle] || null;
  const prodTitle = prod && prod.title || "";
  const prodSubline = prod && prod.subline || "";
  const prodCoord = prod && prod.coord || "";
  const liveTitle = liveLabel && liveLabel.title;
  const liveSubline = liveLabel && liveLabel.subline;
  const liveCoord = liveLabel && liveLabel.coord;
  const liveShowCoords = liveLabel && liveLabel.showCoords;
  const label3d = React.useMemo(() => liveLabel ? { title: liveLabel.title, subline: liveLabel.subline, coord: liveLabel.coord, showCoords: liveLabel.showCoords } : { title: prodTitle, subline: prodSubline, coord: prodCoord, showCoords: true }, [liveTitle, liveSubline, liveCoord, liveShowCoords, prodTitle, prodSubline, prodCoord]);
  if (!prod) {
    return /* @__PURE__ */ React.createElement("div", { ref: wrapRef, style: { position: "relative", width: "100%", aspectRatio: "1/1", background: "var(--bone)", border: "1px solid var(--ink)" } }, fallback && /* @__PURE__ */ React.createElement("img", { src: fallback, alt: "", style: { width: "100%", height: "100%", objectFit: "cover" } }));
  }
  return /* @__PURE__ */ React.createElement("div", { ref: wrapRef }, /* @__PURE__ */ React.createElement("div", { style: { position: "relative", width: "100%", aspectRatio: "1/1", background: "var(--bone)", border: "1px solid var(--ink)", overflow: "hidden" } }, inView && /* @__PURE__ */ React.createElement(
    Model3DViewer,
    {
      url: prod.glb,
      fallback: fallback || cfp.glbFallback,
      label: label3d,
      height: "100%",
      autoRotate: true,
      autoRotateSpeed: -0.6,
      showHint: true
    }
  ), !inView && fallback && // Pre-load placeholder — same hero photo so layout doesn't jump
  // when the canvas mounts. Three.js will replace this on first
  // paint, no flicker.
  /* @__PURE__ */ React.createElement("img", { src: fallback, alt: "", style: { width: "100%", height: "100%", objectFit: "cover" } })), /* @__PURE__ */ React.createElement(ProductARBlock, { prod }));
}
function ProductARBlock({ prod }) {
  if (!prod || !prod.usdz) return null;
  return /* @__PURE__ */ React.createElement("div", { style: {
    marginTop: 24,
    padding: 20,
    background: "var(--bone, #F7F8F6)",
    border: "1px solid var(--ink, #1A1F26)",
    display: "grid",
    gridTemplateColumns: "minmax(0,1fr) auto",
    gap: 24,
    alignItems: "center"
  } }, /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("div", { className: "eyebrow", style: { fontSize: 10, letterSpacing: "0.28em", textTransform: "uppercase", color: "var(--stone, #888)", marginBottom: 8 } }, "View in your space"), /* @__PURE__ */ React.createElement("div", { style: { fontSize: 20, fontWeight: 600, letterSpacing: "-0.005em", marginBottom: 12 } }, "See it on your shelf in AR."), /* @__PURE__ */ React.createElement(
    "a",
    {
      href: prod.usdz,
      rel: "ar",
      download: "cityform.usdz",
      style: {
        display: "inline-block",
        padding: "12px 24px",
        background: "var(--ink, #1A1F26)",
        color: "var(--bone, #F7F8F6)",
        fontSize: 11,
        letterSpacing: "0.24em",
        textTransform: "uppercase",
        fontWeight: 600,
        textDecoration: "none",
        border: "1px solid var(--ink, #1A1F26)"
      }
    },
    "Tap to view in AR"
  ), /* @__PURE__ */ React.createElement("p", { style: { fontSize: 12, color: "var(--ink-soft, #6E7479)", lineHeight: 1.5, marginTop: 12, marginBottom: 0 } }, "On iPhone: tap to launch AR Quick Look. On desktop: scan the QR with your phone camera.")), prod.qr && /* @__PURE__ */ React.createElement("div", { style: { width: 120, height: 120, flexShrink: 0, padding: 6, background: "#fff", border: "1px solid var(--line, #ddd)" } }, /* @__PURE__ */ React.createElement(
    "img",
    {
      src: prod.qr,
      alt: "Scan with phone camera to view in AR",
      style: { display: "block", width: "100%", height: "100%", objectFit: "contain" }
    }
  )));
}
Object.assign(window, {
  useV2,
  HomePage,
  HeroV2,
  HeroModel,
  HeroPhotoStack,
  HeroPlan,
  HeroTriptych,
  MarqueeStripV2,
  SignatureProcess,
  ProcessStage,
  FeaturedCollection,
  TheTwelveGrid,
  CommissionPreviewV2,
  ARShelfModule,
  PullQuoteV2,
  ArchiveSection,
  PressStripV2,
  /* v3 additions */
  AtlasHome,
  ProcessBuild,
  /* v4 — per-product 3D preview */
  ProductModel3D
});
window.ARShelfModule = ARShelfModule;
window.ArchiveSection = ArchiveSection;
window.AtlasHome = AtlasHome;
window.CommissionPreviewV2 = CommissionPreviewV2;
window.FeaturedCollection = FeaturedCollection;
window.HeroModel = HeroModel;
window.HeroPhotoStack = HeroPhotoStack;
window.HeroPlan = HeroPlan;
window.HeroTriptych = HeroTriptych;
window.HeroV2 = HeroV2;
window.HomePage = HomePage;
window.MarqueeStripV2 = MarqueeStripV2;
window.PressStripV2 = PressStripV2;
window.ProcessBuild = ProcessBuild;
window.ProcessStage = ProcessStage;
window.ProductARBlock = ProductARBlock;
window.ProductModel3D = ProductModel3D;
window.PullQuoteV2 = PullQuoteV2;
window.SignatureProcess = SignatureProcess;
window.StageBadge = StageBadge;
window.TheTwelveGrid = TheTwelveGrid;
})();
